import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  Divider,
  createTheme,
  InputLabel,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  aprovarInteresado,
  deleteCurso,
  deleteCursoRating,
  getCursoById,
  getCursoRatingsByCurso,
  postCurso,
  recordatorioInteresado,
  setCursoRatingValidated,
  updateCurso,
  asegurarEnlaceInscripcion,
  regenerateInscripcionEnlace,
} from "../../../../api/curso";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Visibility,
  GetApp,
  FlashOn,
  Clear,
  HowToReg,
  Link as LinkIcon,
  Public,
} from "@material-ui/icons";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { SERVER_URL } from "../../../../api";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import Editor from "../../../components/editor/Editor";
import MultiTabBlock from "../../../components/MultiTabBlock";
import { getUserTypes } from "../../../../api/userType";
import { shallowEqual, useSelector } from "react-redux";
import { isCursoReadOnly } from "../../../../_helpers/backofficePermissions";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  formatDateForInput,
  getNonEmpty,
  getFileType,
} from "../../../../utils/helpers";
import { Autocomplete } from "@material-ui/lab";
import { getUsers, postUser, updateUser } from "../../../../api/user";
import { AlertTriangle, Check, Mail } from "lucide-react";
import { PersonAdd } from "@material-ui/icons";
import { UserFormModal } from "../../../components/UserFormModal";
import { IconButton } from "@material-ui/core";
import * as XLSX from "xlsx";
import ImageStorageSelectorDialog from "../../../components/dialogs/ImageStorageSelectorDialog";
import { WEB_URL } from "../../../../constants/utils.constants";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const normalizeBaseUrl = (url) => (url || "").replace(/\/+$/, "");

const getCursoBasePathByLang = (lang) => {
  switch ((lang || "").toLowerCase()) {
    case "es":
      return "/es/formacion-actedi";
    case "en":
      return "/en/actedi-training";
    case "ca":
    default:
      return "/formacio-actedi";
  }
};

/** Ruta pública de la ficha de un curso (no el listado). */
const getCursoDetailPathByLang = (lang) => {
  switch ((lang || "").toLowerCase()) {
    case "es":
      return "/es/formacion";
    case "en":
      return "/en/formacion";
    case "ca":
    default:
      return "/formacion";
  }
};

const slugifyCursoUrl = (text) => {
  if (!text) return "";
  const a = "àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
  const b = "aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  const p = new RegExp(a.split("").join("|"), "g");
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/&/g, "-y-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

const resolveCursoDetailSlug = (cursoData, lang = "es") => {
  if (cursoData?.urlCurso) return cursoData.urlCurso;
  const enlaceSlug =
    cursoData?.enlace?.[lang] ||
    cursoData?.enlace?.es ||
    cursoData?.enlace?.ca ||
    cursoData?.enlace?.en;
  if (enlaceSlug) return enlaceSlug;
  let titulo = cursoData?.titulo?.[lang] || cursoData?.titulo?.es;
  if (typeof cursoData?.titulo === "string") titulo = cursoData.titulo;
  return slugifyCursoUrl(titulo);
};

const buildPublicUrl = ({ basePath, slug }) => {
  const base = normalizeBaseUrl(WEB_URL);
  const path = `${basePath || ""}/${slug || ""}`.replace(/\/+$/, "");
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
};

const buildInscripcionEnlaceUrl = (cursoData, lang = "es") => {
  if (!cursoData?.inscripcionEnlaceToken) return "";
  const slug = resolveCursoDetailSlug(cursoData, lang);
  if (!slug) return "";
  const baseUrl = buildPublicUrl({
    basePath: getCursoDetailPathByLang(lang),
    slug,
  });
  return `${baseUrl}?inscripcion=${encodeURIComponent(cursoData.inscripcionEnlaceToken)}`;
};

function generateClientInscripcionToken() {
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(24);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 15)}`;
}

const METODO_PAGO_LABELS = {
  tarjeta: "Tarjeta",
  paypal: "PayPal",
  iban: "IBAN",
  gratis: "Gratis",
};

function formatImporte(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return null;
  return `${Number(amount).toFixed(2)} €`;
}

function formatPagoDisplay(paymentInfo, hasUser) {
  if (!hasUser || !paymentInfo) return "---";
  const importe = formatImporte(paymentInfo.amount);
  const metodo =
    METODO_PAGO_LABELS[paymentInfo.metodoPago] ||
    paymentInfo.metodoPago ||
    "";
  if (!importe) return "---";
  return metodo ? `${importe} · ${metodo}` : importe;
}

function resolveInscripcionCodigoPago(insc) {
  return insc?.paymentInfo?.codigoPago || insc?.codigoPago || insc?.code || "";
}

function getEmptyCurso() {
  return {
    tipoCurso: "curso",
    titulo: {},
    orden: 0,
    imageURL: "",
    imageGridURL: "",
    code: "",
    nRegistro: "",
    creditos: "",
    creditosDefinidos: true,
    registroWeb: false,
    inscripcionSoloEnlace: false,
    fechaIni: null,
    fechaFin: null,
    pricing: [],
    documentos: [],
    inscripciones: [],
    docentes: [],
    desc: {},
    breve: {},
    programa: {},
    active: true,
    modalidad: "",
    cursoCompleto: false,
  };
}

export default function EditCursoPage() {
  const [curso, setCurso] = useState(getEmptyCurso());
  const [priceId, setPriceId] = useState(null);
  const [inscripcionId, setInscriptionId] = useState(null);
  const [documentoId, setDocumentoId] = useState(null);
  const [docenteId, setDocenteId] = useState(null);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedLogoGrid, setSelectedLogoGrid] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openImageSelector, setOpenImageSelector] = useState(false);
  const [openImageGridSelector, setOpenImageGridSelector] = useState(false);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshOrder, setRefreshOrder] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const cursoId = useParams().id;
  const history = useHistory();
  const [refreshInscritos, setRefreshInscritos] = useState(false);
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const languages = useSelector(
    (store) => store.authentication?.languages,
    shallowEqual,
  );
  // Estados para el modal de inscripciones
  const [openInscripcionModal, setOpenInscripcionModal] = useState(false);
  const [currentInscripcion, setCurrentInscripcion] = useState(null);
  const [selectedUserInscripcion, setSelectedUserInscripcion] = useState(null);
  const [editedUserData, setEditedUserData] = useState(null);
  const [isCreatingNewUser, setIsCreatingNewUser] = useState(false);
  const [openModalAddUser, setOpenModalAddUser] = useState(false);
  const [userSearchText, setUserSearchText] = useState("");
  const [userSearchFiltered, setUserSearchFiltered] = useState("");
  // Estados para el modal de docentes
  const [openDocenteModal, setOpenDocenteModal] = useState(false);
  const [currentDocente, setCurrentDocente] = useState(null);
  const [selectedUserDocente, setSelectedUserDocente] = useState(null);
  const [isCreatingNewUserDocente, setIsCreatingNewUserDocente] = useState(
    false,
  );
  const [openModalAddUserDocente, setOpenModalAddUserDocente] = useState(false);
  const [docenteSearchText, setDocenteSearchText] = useState("");
  const [docenteSearchFiltered, setDocenteSearchFiltered] = useState("");
  // Estado para el menú de aprobación
  const [anchorElAprovado, setAnchorElAprovado] = useState(null);
  const [
    selectedInscripcionForAprovado,
    setSelectedInscripcionForAprovado,
  ] = useState(null);
  const [newAprovadoValue, setNewAprovadoValue] = useState(null);
  const [
    inscripcionIdForRecordatorio,
    setInscripcionIdForRecordatorio,
  ] = useState(null);
  const [ratingsList, setRatingsList] = useState([]);
  const [loadingRatings, setLoadingRatings] = useState(false);
  const [refreshRatings, setRefreshRatings] = useState(0);
  const [generatingEnlace, setGeneratingEnlace] = useState(false);
  const [ratingIdToDelete, setRatingIdToDelete] = useState(null);
  const [valoracionCommentModal, setValoracionCommentModal] = useState({
    open: false,
    text: "",
    anchorLeft: 0,
    anchorTop: 0,
  });

  useEffect(() => {
    setRefreshInscritos(false);
  }, [refreshInscritos]);

  useEffect(() => {
    if (!cursoId) return;
    setLoadingRatings(true);
    getCursoRatingsByCurso(cursoId)
      .then((res) => setRatingsList(res.data || []))
      .catch(() => setRatingsList([]))
      .finally(() => setLoadingRatings(false));
  }, [cursoId, activeTab, refreshRatings]);

  // Debounce para la búsqueda de usuarios en el modal de inscripciones
  useEffect(() => {
    const trimmedText = userSearchText.trim();

    // Si tiene menos de 3 caracteres, limpiar el filtro
    if (trimmedText.length < 3 && trimmedText.length > 0) {
      setUserSearchFiltered("");
      return;
    }

    // Si está vacío, limpiar inmediatamente
    if (trimmedText.length === 0) {
      setUserSearchFiltered("");
      return;
    }

    // Si tiene 3 o más caracteres, aplicar debounce de 1 segundo
    const timeoutId = setTimeout(() => {
      setUserSearchFiltered(trimmedText);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [userSearchText]);

  // Debounce para la búsqueda de docentes en el modal de docentes
  useEffect(() => {
    const trimmedText = docenteSearchText.trim();
    if (trimmedText.length < 3 && trimmedText.length > 0) {
      setDocenteSearchFiltered("");
      return;
    }
    if (trimmedText.length === 0) {
      setDocenteSearchFiltered("");
      return;
    }
    const timeoutId = setTimeout(() => {
      setDocenteSearchFiltered(trimmedText);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [docenteSearchText]);

  // Variable para determinar si es modo readonly
  const isReadonly = isCursoReadOnly(user?.role);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const isPersonalizadaBackoffice =
    location?.pathname?.startsWith("/edit-formacion-personalizada") ||
    location?.pathname?.startsWith("/formaciones-personalizadas");
  const isPersonalizadaCurso = curso?.tipoCurso === "continua_personalizada";

  const getAfterSaveRedirect = (cursoObj) => {
    const isPersonalizada =
      cursoObj?.tipoCurso === "continua_personalizada" ||
      isPersonalizadaBackoffice;
    return isPersonalizada ? "/formaciones-personalizadas" : "/cursos";
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (isPersonalizadaBackoffice) {
      if (tab === "valoraciones") {
        setActiveTab(5);
        history.replace(location.pathname);
      } else if (tab === "seo") {
        setActiveTab(6);
        history.replace(location.pathname);
      }
      return;
    }

    if (tab === "inscripciones") {
      setActiveTab(3);
      history.replace(location.pathname);
    } else if (tab === "precios") {
      setActiveTab(1);
      history.replace(location.pathname);
    } else if (tab === "documentos") {
      setActiveTab(2);
      history.replace(location.pathname);
    } else if (tab === "docentes") {
      setActiveTab(4);
      history.replace(location.pathname);
    } else if (tab === "valoraciones") {
      setActiveTab(5);
      history.replace(location.pathname);
    } else if (tab === "seo") {
      setActiveTab(6);
      history.replace(location.pathname);
    }
  }, [location.search, history, location.pathname]);

  // Forzar tipo por defecto y limpiar campos no aplicables en altas desde la ruta personalizada
  useEffect(() => {
    if (!isPersonalizadaBackoffice) return;
    if (cursoId) return;
    setCurso((prev) => ({
      ...prev,
      tipoCurso: "continua_personalizada",
      pricing: [],
      documentos: [],
      inscripciones: [],
      docentes: [],
    }));
  }, [isPersonalizadaBackoffice, cursoId]);

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  // Limpiar paginación cuando cambia el cursoId
  useEffect(() => {
    if (cursoId) {
      // Limpiar localStorage de paginación para todas las tablas de este curso
      localStorage.removeItem(`curso-${cursoId}-inscripciones_currentPage`);
      localStorage.removeItem(`curso-${cursoId}-docentes_currentPage`);
      localStorage.removeItem(`curso-${cursoId}-pricing_currentPage`);
      localStorage.removeItem(`curso-${cursoId}-documentos_currentPage`);
    }
  }, [cursoId]);

  useEffect(() => {
    getUsers()
      .then((res) => {
        const allUsers = res.data || [];
        setUsers(allUsers);
      })
      .catch((error) => {
        console.log(error);
        alertError({
          error: error,
          customMessage: "Could not get users.",
        });
        history.push("/cursos");
      });
    getUserTypes()
      .then((res) => {
        setUserTypes(res.data);
      })
      .catch((error) => {
        console.log(error);
        alertError({
          error: error,
          customMessage: "Could not get users types.",
        });
        history.push("/cursos");
      });
    if (!cursoId) {
      disableLoadingData();
      return;
    }
    getCursoById(cursoId, { join: true })
      .then((res) => {
        if (res.status === 200) {
          const curso = res.data;
          setCurso(curso);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get curso." });
        history.push("/cursos");
      });
  }, [cursoId, refreshInscritos, disableLoadingData, history]);

  const validarFechas = (fechaIni, fechaFin) => {
    // En cursos personalizados, las fechas no son obligatorias
    if (isPersonalizadaCurso) return true;

    const inicio = new Date(fechaIni);
    const fin = new Date(fechaFin);

    if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) {
      return false;
    }

    if (inicio > fin) {
      return false;
    }

    return true;
  };

  const activarInscripcionSoloEnlace = async (cursoActual) => {
    if (cursoActual.inscripcionEnlaceToken) {
      setCurso({
        ...cursoActual,
        registroWeb: true,
        inscripcionSoloEnlace: true,
      });
      return;
    }
    setGeneratingEnlace(true);
    try {
      const persistedId = cursoId || cursoActual._id;
      if (persistedId) {
        const res = await asegurarEnlaceInscripcion(persistedId, {
          registroWeb: true,
        });
        setCurso({
          ...cursoActual,
          registroWeb: true,
          inscripcionSoloEnlace: true,
          inscripcionEnlaceToken: res.data.inscripcionEnlaceToken,
        });
      } else {
        setCurso({
          ...cursoActual,
          registroWeb: true,
          inscripcionSoloEnlace: true,
          inscripcionEnlaceToken: generateClientInscripcionToken(),
        });
      }
    } catch (error) {
      alertError({
        error,
        customMessage:
          error?.response?.data?.message ||
          "No se pudo generar el enlace de inscripción.",
      });
    } finally {
      setGeneratingEnlace(false);
    }
  };

  const regenerarEnlaceInscripcionHandler = async () => {
    if (isReadonly) return;
    setGeneratingEnlace(true);
    try {
      const persistedId = cursoId || curso._id;
      if (persistedId) {
        const res = await regenerateInscripcionEnlace(persistedId, {
          registroWeb: !!curso.registroWeb,
        });
        setCurso({
          ...curso,
          registroWeb: res.data.registroWeb ?? curso.registroWeb,
          inscripcionSoloEnlace: true,
          inscripcionEnlaceToken: res.data.inscripcionEnlaceToken,
        });
      } else {
        setCurso({
          ...curso,
          inscripcionSoloEnlace: true,
          inscripcionEnlaceToken: generateClientInscripcionToken(),
        });
      }
      alertSuccess("Enlace regenerado correctamente.");
    } catch (error) {
      alertError({
        error,
        customMessage:
          error?.response?.data?.message ||
          "No se pudo regenerar el enlace.",
      });
    } finally {
      setGeneratingEnlace(false);
    }
  };

  function saveCurso() {
    if (isReadonly) return; // No permitir guardar si es consultor

    let saveCurso = { ...curso };
    if (saveCurso.inscripcionSoloEnlace) {
      saveCurso.registroWeb = true;
    }
    const isValid = validarFechas(saveCurso.fechaIni, saveCurso.fechaFin);
    if (!isValid) {
      alertError({ customMessage: "Las fechas no son validas" });
      return;
    }
    if (saveCurso.lock) {
      alertError({
        customMessage: "Este curso ya ha empezado no se puede modificar",
      });
      return;
    }
    if (saveCurso.fechaIni) {
      saveCurso.fechaIni = new Date(saveCurso.fechaIni).toISOString();
    }
    if (saveCurso.fechaFin) {
      saveCurso.fechaFin = new Date(saveCurso.fechaFin).toISOString();
    }
    // Si un docente deja de estar activo, se borran sus certificados
    if (saveCurso.docentes && Array.isArray(saveCurso.docentes)) {
      saveCurso.docentes = saveCurso.docentes.map((d) =>
        d.active === false
          ? { ...d, certificado: "", certificadoDirector: "" }
          : d,
      );
    }
    if (!cursoId) {
      postCurso(saveCurso, selectedLogo, selectedLogoGrid)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Curso successfully created.",
            });
            history.push(getAfterSaveRedirect(saveCurso));
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save curso.",
          });
        });
    } else {
      updateCurso(cursoId, saveCurso, selectedLogo, selectedLogoGrid)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push(getAfterSaveRedirect(saveCurso));
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (element, lang) => (event) => {
    if (isReadonly) return; // No permitir cambios si es consultor

    if (lang) {
      if (event.target.value === " ") return;

      if (!curso[element]) curso[element] = {};
      let newText = curso[element];
      newText[lang] = event.target.value;
      setCurso({ ...curso, [element]: newText });
    } else setCurso({ ...curso, [element]: event.target.value });
  };

  const handleChangeEditor = (element, lang, value) => {
    if (isReadonly) return; // No permitir cambios si es consultor

    if (lang) {
      if (value === " ") return;
      if (!curso[element]) curso[element] = {};
      let newText = curso[element];
      newText[lang] = value;
      setCurso({ ...curso, [element]: newText });
    } else setCurso({ ...curso, [element]: value });
  };

  const handleChangeSelect = (element, newValue) => {
    if (isReadonly) return; // No permitir cambios si es consultor
    setCurso({ ...curso, [element]: newValue });
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <TextField
              id={`titulo`}
              label="Titulo"
              value={
                curso.titulo && curso.titulo[lang] ? curso.titulo[lang] : ""
              }
              onChange={handleChange("titulo", lang)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`lugar`}
              label="Lugar"
              value={curso.lugar && curso.lugar[lang] ? curso.lugar[lang] : ""}
              onChange={handleChange("lugar", lang)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required={!isPersonalizadaCurso}
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`direccion`}
              label="Dirección"
              value={curso.direccion}
              onChange={handleChange("direccion")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              disabled={isReadonly}
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <TextField
              id={`code`}
              label="Código del curso"
              value={curso.code}
              onChange={handleChange("code")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`nRegistro`}
              label="Nº de regristo de la actividad"
              value={curso.nRegistro}
              onChange={handleChange("nRegistro")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`organizador`}
              label="Docente / Organizador"
              value={curso.organizador}
              onChange={handleChange("organizador")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              disabled={isReadonly}
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <TextField
              id={`fechaIni`}
              label="Fecha Inicio"
              value={curso.fechaIni ? formatDateForInput(curso.fechaIni) : ""}
              onChange={handleChange("fechaIni")}
              InputLabelProps={{
                shrink: true,
              }}
              type="datetime-local"
              margin="normal"
              variant="outlined"
              required={!isPersonalizadaCurso}
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`fechaFin`}
              label="Fecha Fin"
              value={curso.fechaFin ? formatDateForInput(curso.fechaFin) : ""}
              onChange={handleChange("fechaFin")}
              InputLabelProps={{
                shrink: true,
              }}
              type="datetime-local"
              margin="normal"
              variant="outlined"
              required={!isPersonalizadaCurso}
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`duracion`}
              label="Duración"
              value={curso.duracion}
              onChange={handleChange("duracion")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              disabled={isReadonly}
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-2">
            <TextField
              id={`creditos`}
              label="Créditos"
              value={curso.creditos}
              onChange={handleChange("creditos")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required={!isPersonalizadaCurso}
              disabled={isReadonly}
            />
          </div>
          <div className="col-md-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso.creditosDefinidos !== false}
                  onChange={() =>
                    !isReadonly &&
                    setCurso({
                      ...curso,
                      creditosDefinidos:
                        curso.creditosDefinidos === false ? true : false,
                    })
                  }
                  name="checkCreditosDefinidos"
                  disabled={isReadonly}
                />
              }
              label="Créditos definidos"
              style={{ marginTop: "16px" }}
            />
          </div>
          <div className="col-md-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso.active || false}
                  onChange={() =>
                    !isReadonly && setCurso({ ...curso, active: !curso.active })
                  }
                  name="checkActive"
                  disabled={isReadonly}
                />
              }
              label="Active"
            />
          </div>
          <div className="col-md-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso.isZoom}
                  onChange={() =>
                    !isReadonly && setCurso({ ...curso, isZoom: !curso.isZoom })
                  }
                  name="checkZoom"
                  disabled={isReadonly}
                />
              }
              label="Zoom"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              style={{
                border: "1px solid #e4e6ef",
                borderRadius: "8px",
                padding: "20px 24px",
                backgroundColor: "#f9fafb",
                marginBottom: "8px",
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{ gap: 10, marginBottom: 8 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "8px",
                    backgroundColor: "rgba(54, 153, 255, 0.12)",
                    color: "#3699FF",
                    flexShrink: 0,
                  }}
                >
                  <HowToReg />
                </div>
                <div>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 0, lineHeight: 1.3 }}
                  >
                    Inscripción web
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Visible en la web · abierta o solo con enlace
                  </Typography>
                </div>
              </div>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginBottom: 16, lineHeight: 1.5 }}
              >
                El curso puede estar visible en la web aunque desactives la
                inscripción. Cuando la actives, elige si cualquier usuario puede
                inscribirse desde la ficha del curso o solo quienes reciban un
                enlace personalizado de ACTEDI.
              </Typography>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!curso.registroWeb}
                    onChange={() => {
                      if (isReadonly) return;
                      const nextRegistroWeb = !curso.registroWeb;
                      setCurso({
                        ...curso,
                        registroWeb: nextRegistroWeb,
                        ...(nextRegistroWeb
                          ? {}
                          : { inscripcionSoloEnlace: false }),
                      });
                    }}
                    name="checkRegistroWeb"
                    disabled={isReadonly}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    Permitir inscripción desde la web
                  </Typography>
                }
              />

              {curso.registroWeb ? (
                <>
                  <Divider style={{ margin: "16px 0" }} />
                  <Typography
                    variant="subtitle2"
                    style={{ fontWeight: 600, marginBottom: 12 }}
                  >
                    ¿Quién puede inscribirse?
                  </Typography>
                  <RadioGroup
                    value={curso.inscripcionSoloEnlace ? "enlace" : "abierta"}
                    onChange={async (e) => {
                      if (isReadonly) return;
                      if (e.target.value === "enlace") {
                        await activarInscripcionSoloEnlace(curso);
                      } else {
                        setCurso({ ...curso, inscripcionSoloEnlace: false });
                      }
                    }}
                  >
                    <FormControlLabel
                      value="abierta"
                      disabled={isReadonly}
                      control={<Radio color="primary" />}
                      style={{ alignItems: "flex-start", marginBottom: 8 }}
                      label={
                        <span className="d-flex" style={{ gap: 8 }}>
                          <Public
                            fontSize="small"
                            style={{ color: "#3699FF", marginTop: 2, flexShrink: 0 }}
                          />
                          <span>
                            <Typography
                              variant="body2"
                              component="span"
                              display="block"
                              style={{ fontWeight: 500 }}
                            >
                              Inscripción abierta
                            </Typography>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              display="block"
                              style={{ lineHeight: 1.4 }}
                            >
                              Cualquier usuario registrado puede inscribirse desde
                              la ficha pública del curso.
                            </Typography>
                          </span>
                        </span>
                      }
                    />
                    <FormControlLabel
                      value="enlace"
                      disabled={isReadonly}
                      control={<Radio color="primary" />}
                      style={{ alignItems: "flex-start" }}
                      label={
                        <span className="d-flex" style={{ gap: 8 }}>
                          <LinkIcon
                            fontSize="small"
                            style={{ color: "#3699FF", marginTop: 2, flexShrink: 0 }}
                          />
                          <span>
                            <Typography
                              variant="body2"
                              component="span"
                              display="block"
                              style={{ fontWeight: 500 }}
                            >
                              Solo con enlace personalizado
                            </Typography>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              display="block"
                              style={{ lineHeight: 1.4 }}
                            >
                              El curso sigue siendo visible, pero solo quienes
                              reciban el enlace podrán inscribirse.
                            </Typography>
                          </span>
                        </span>
                      }
                    />
                  </RadioGroup>

                  {curso.inscripcionSoloEnlace && (
                    <div
                      style={{
                        marginTop: 16,
                        padding: "16px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        border: "1px solid #e4e6ef",
                      }}
                    >
                      <Typography
                        variant="body2"
                        className="d-flex align-items-center"
                        style={{ fontWeight: 500, marginBottom: 8, gap: 6 }}
                      >
                        <LinkIcon fontSize="small" style={{ color: "#3699FF" }} />
                        Enlace de inscripción
                      </Typography>
                      {generatingEnlace ? (
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: 8, color: "#7e8299" }}
                        >
                          <CircularProgress size={18} />
                          <Typography variant="body2" color="textSecondary">
                            Generando enlace…
                          </Typography>
                        </div>
                      ) : curso.inscripcionEnlaceToken ? (
                        buildInscripcionEnlaceUrl(curso) ? (
                        <>
                          <TextField
                            label="URL para compartir"
                            value={buildInscripcionEnlaceUrl(curso)}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                          />
                          <div className="d-flex flex-wrap mt-2" style={{ gap: 8 }}>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              disabled={isReadonly}
                              onClick={() => {
                                const url = buildInscripcionEnlaceUrl(curso);
                                if (url && navigator.clipboard?.writeText) {
                                  navigator.clipboard.writeText(url);
                                  alertSuccess(
                                    "Enlace copiado al portapapeles.",
                                  );
                                }
                              }}
                            >
                              Copiar enlace
                            </Button>
                            <Button
                              variant="outlined"
                              color="secondary"
                              size="small"
                              disabled={isReadonly || generatingEnlace}
                              onClick={regenerarEnlaceInscripcionHandler}
                            >
                              Regenerar enlace
                            </Button>
                          </div>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            display="block"
                            style={{ marginTop: 8, lineHeight: 1.4 }}
                          >
                            Envía este enlace solo a las personas autorizadas.
                            Si lo regeneras, el enlace anterior dejará de
                            funcionar.
                            {!cursoId && !curso._id
                              ? " Recuerda guardar el curso para que el enlace quede activo en la web."
                              : ""}
                          </Typography>
                        </>
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              style={{ lineHeight: 1.5 }}
                            >
                              Completa la URL amigable del curso (campo
                              «Enlace») para ver el enlace completo. El token ya
                              está generado.
                            </Typography>
                            <TextField
                              label="Token de inscripción"
                              value={curso.inscripcionEnlaceToken}
                              fullWidth
                              margin="dense"
                              variant="outlined"
                              InputProps={{ readOnly: true }}
                              InputLabelProps={{ shrink: true }}
                              style={{ marginTop: 8 }}
                            />
                          </>
                        )
                      ) : null}
                    </div>
                  )}
                </>
              ) : (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginTop: 12, lineHeight: 1.5 }}
                >
                  Con la inscripción web desactivada no se mostrará el botón de
                  inscripción en la web, aunque el curso siga siendo visible.
                </Typography>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <Autocomplete
              options={["Online", "Híbrido", "Presencial"]}
              value={curso.modalidad || ""}
              onChange={(event, newValue) => {
                if (!isReadonly) {
                  setCurso({ ...curso, modalidad: newValue || "" });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Modalidad"
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  disabled={isReadonly}
                />
              )}
            />
          </div>
          <div className="col-md-4">
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso.cursoCompleto || false}
                  onChange={() =>
                    !isReadonly &&
                    setCurso({ ...curso, cursoCompleto: !curso.cursoCompleto })
                  }
                  name="checkCursoCompleto"
                  disabled={isReadonly}
                />
              }
              label="Curso completo"
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <InputLabel>
              Imagen Cartel 1200x675<sub>(16:9)</sub>
            </InputLabel>
            {!isReadonly && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "16px",
                  marginBottom: "16px",
                  flexWrap: "wrap",
                }}
              >
                <label htmlFor={"upload-media"} className="ml-0">
                  <input
                    style={{ display: "none" }}
                    id={"upload-media"}
                    name={"upload-media"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                      setSelectedLogo(e.target.files[0]);
                    }}
                  />
                  <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                  >
                    {selectedLogo || (curso.imageURL && curso.imageURL !== "")
                      ? "Change media"
                      : "Upload media"}
                  </Button>
                </label>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenImageSelector(true)}
                >
                  Seleccionar de galería
                </Button>
              </div>
            )}
            {(selectedLogo || (curso.imageURL && curso.imageURL !== "")) && (
              <>
                <Tooltip title={"Preview"}>
                  <Button
                    size="small"
                    onClick={() => setOpenPreviewDialog(true)}
                    style={{
                      ...buttonsStyle,
                      marginRight: "15px",
                    }}
                  >
                    <Visibility />
                  </Button>
                </Tooltip>
                <PreviewDialog
                  title={"Preview"}
                  open={openPreviewDialog}
                  setOpen={setOpenPreviewDialog}
                  file={selectedLogo}
                  src={
                    selectedLogo
                      ? URL.createObjectURL(selectedLogo)
                      : `${SERVER_URL}/${curso.imageURL}`
                  }
                />
                {!isReadonly && (
                  <Tooltip title={"Delete"}>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedLogo(null);
                        setCurso({
                          ...curso,
                          imageURL: null,
                        });
                      }}
                    >
                      <Delete />
                    </Button>
                  </Tooltip>
                )}
              </>
            )}
            <br />
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: "8px" }}
            >
              Imagen para Grid 1200x675<sub>(16:9)</sub> (Opcional)
            </Typography>
            {!isReadonly && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "16px",
                  marginBottom: "16px",
                  flexWrap: "wrap",
                }}
              >
                <label htmlFor={"upload-media-grid"} className="ml-0">
                  <input
                    style={{ display: "none" }}
                    id={"upload-media-grid"}
                    name={"upload-media-grid"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                      setSelectedLogoGrid(e.target.files[0]);
                    }}
                  />
                  <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                  >
                    {selectedLogoGrid ||
                    (curso.imageGridURL && curso.imageGridURL !== "")
                      ? "Change media grid"
                      : "Upload media grid"}
                  </Button>
                </label>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenImageGridSelector(true)}
                >
                  Seleccionar de galería
                </Button>
              </div>
            )}
            {(selectedLogoGrid ||
              (curso.imageGridURL && curso.imageGridURL !== "")) && (
              <>
                <Tooltip title={"Preview"}>
                  <Button
                    size="small"
                    onClick={() => setOpenPreviewDialog(2)}
                    style={{
                      ...buttonsStyle,
                      marginRight: "15px",
                    }}
                  >
                    <Visibility />
                  </Button>
                </Tooltip>
                <PreviewDialog
                  title={"Preview Grid"}
                  open={openPreviewDialog === 2}
                  setOpen={setOpenPreviewDialog}
                  file={selectedLogoGrid}
                  src={
                    selectedLogoGrid
                      ? URL.createObjectURL(selectedLogoGrid)
                      : `${SERVER_URL}/${curso.imageGridURL}`
                  }
                />
                {!isReadonly && (
                  <Tooltip title={"Delete"}>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedLogoGrid(null);
                        setCurso({
                          ...curso,
                          imageGridURL: null,
                        });
                      }}
                    >
                      <Delete />
                    </Button>
                  </Tooltip>
                )}
              </>
            )}
          </div>
        </div>
        <br />
        <Typography variant="h6" gutterBottom>
          Descripción
        </Typography>
        <Editor
          body={(curso.desc && curso.desc[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("desc", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Enter description here..."}
          readOnly={isReadonly}
        />
        <br />
        <Typography variant="h6" gutterBottom>
          Resumen
        </Typography>
        <Editor
          body={(curso.breve && curso.breve[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("breve", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Enter resum here..."}
          readOnly={isReadonly}
        />
        <br />
        <Typography variant="h6" gutterBottom>
          Programa
        </Typography>
        <Editor
          body={(curso.programa && curso.programa[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("programa", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Enter programa here..."}
          readOnly={isReadonly}
        />
        <br />
        <Typography variant="h6" gutterBottom>
          Dirigido A
        </Typography>
        <Editor
          body={(curso.dirigido && curso.dirigido[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("dirigido", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Enter dirigido a here..."}
          readOnly={isReadonly}
        />
      </>
    );
  };

  const renderMultilanguageTabContentEnlace = (lang) => {
    return (
      <>
        <TextField
          id={`enlace`}
          label="Url amigable"
          value={curso.enlace && curso.enlace[lang] ? curso.enlace[lang] : ""}
          onChange={handleChange("enlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
          disabled={isReadonly}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ display: "block", marginTop: "-4px", marginBottom: "8px" }}
        >
          <span style={{ fontFamily: "monospace" }}>
            {buildPublicUrl({
              basePath: getCursoDetailPathByLang(lang),
              slug: (curso.enlace && curso.enlace[lang]) || "",
            })}
          </span>
        </Typography>
        <TextField
          id={`tituloEnlace`}
          label="Titulo SEO"
          value={
            curso.tituloEnlace && curso.tituloEnlace[lang]
              ? curso.tituloEnlace[lang]
              : ""
          }
          onChange={handleChange("tituloEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
          disabled={isReadonly}
        />
        <TextField
          id={`descripcionEnlace`}
          label="Descripción SEO"
          value={
            curso.descripcionEnlace && curso.descripcionEnlace[lang]
              ? curso.descripcionEnlace[lang]
              : ""
          }
          onChange={handleChange("descripcionEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
          disabled={isReadonly}
        />
      </>
    );
  };

  const renderContentDatosGenerales = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </>
    );
  };

  const renderContentPricing = () => {
    function getData() {
      let data = [];
      const userTypeCurso = curso?.pricing || [];

      for (const type of userTypeCurso) {
        let elem = {};

        // Obtener el userType del precio (puede venir como string ID o como objeto populado)
        const priceUserTypeId =
          typeof type.userType === "object" && type.userType !== null
            ? type.userType._id || type.userType
            : type.userType;

        // Buscar el userType en la lista usando comparación de strings
        const foundUserType = userTypes.find((x) => {
          const userTypeId = x._id?.toString();
          const priceUserTypeIdStr = priceUserTypeId?.toString();
          return userTypeId === priceUserTypeIdStr;
        });

        // Asignar el nombre del tipo de usuario
        elem.name = foundUserType?.titulo || "(Tipo no encontrado)";
        elem.price =
          type?.value !== undefined && type?.value !== null
            ? parseFloat(type.value).toFixed(2)
            : "0.00";
        elem.info = type?.info || "";
        elem.id = type?._id;
        elem.cursoId = curso._id;
        data.push(elem);
      }
      return data;
    }
    function buttonFormatter(cell) {
      if (isReadonly) return null; // No mostrar botones si es consultor

      const elem = curso?.pricing.find((item) => item._id === cell);
      return (
        <>
          {(user?.role === "admin" || user?.role === "gestor") && (
            <>
              <Tooltip title="Edit">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    history.push(
                      "/edit-curso/" + cursoId + "/edit-pricing/" + cell,
                    );
                  }}
                >
                  <EditIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setPriceId(cell);
                    setOpenConfirmDialog(2);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Tooltip>
            </>
          )}
        </>
      );
    }

    const columns = [
      { dataField: "name", text: "Tipo de Usuario", sort: true },
      { dataField: "price", text: "Precio", sort: true },
      { dataField: "info", text: "Etiqueta Informativa", sort: true },
      ...(isReadonly
        ? []
        : [{ dataField: "id", text: "", formatter: buttonFormatter }]),
    ];

    return (
      <>
        {!isReadonly && (
          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              onClick={() =>
                history.push("/edit-curso/" + cursoId + "/edit-pricing")
              }
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </div>
        )}
        <Table
          data={getData()}
          columns={columns}
          pageKey={`curso-${cursoId}-pricing`}
          disablePaginationPersistence={true}
        />
      </>
    );
  };

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  function handleDeleteMedia(selectedMediaId) {
    if (isReadonly) return; // No permitir eliminación si es consultor

    let baseArray = curso.documentos;
    let updateKey = "documentos";

    // Encontrar el elemento que se va a eliminar para obtener su orden
    const elementToDelete = baseArray.find(
      (item) => item._id === selectedMediaId,
    );

    const deletedOrder = elementToDelete.order;

    // Filtrar el elemento a eliminar
    const filteredArray = baseArray.filter(
      (item) => item._id !== selectedMediaId,
    );

    // Actualizar el orden de los elementos restantes
    const updatedArray = filteredArray.map((item) => {
      if (item.order > deletedOrder) {
        return {
          ...item,
          order: item.order - 1,
        };
      }
      return item;
    });

    // Actualizar el estado
    setCurso((prev) => ({
      ...prev,
      [updateKey]: updatedArray,
    }));
    setRefreshOrder(true);
  }

  const renderContentDocument = () => {
    function nameFormatter(cell) {
      const name = typeof cell === "string" ? cell.split("/").pop() : cell.name;
      return name;
    }
    function getData() {
      let data = [];
      const documentos = curso?.documentos;
      for (const doc of documentos) {
        let elem = {};
        elem.title = getNonEmpty(doc?.title);
        elem.order = doc?.order;
        elem.type = doc?.type;
        elem.url = nameFormatter(doc?.url);
        elem.fullUrl = doc?.url; // URL completa para el modal
        elem.id = doc?._id;
        elem.cursoId = curso._id;
        data.push(elem);
      }
      data.sort((a, b) => a.order - b.order);
      return data;
    }
    function buttonFormatter(cell) {
      if (isReadonly) return null; // No mostrar botones si es consultor

      const elem = curso?.documentos.find((item) => item._id === cell);

      const handleSubtract = () => {
        setCurso((prevCurso) => {
          const currentDocumento = prevCurso.documentos.find(
            (img) => img._id === cell,
          );
          if (!currentDocumento || currentDocumento.order === 0)
            return prevCurso;

          const newOrder = currentDocumento.order - 1;
          const documentoToSwap = prevCurso.documentos.find(
            (img) => img.order === newOrder,
          );

          return {
            ...prevCurso,
            documentos: prevCurso.documentos.map((image) => {
              if (image._id === cell) {
                return { ...image, order: newOrder };
              }
              if (documentoToSwap && image._id === documentoToSwap._id) {
                return { ...image, order: currentDocumento.order };
              }
              return image;
            }),
          };
        });
        setRefreshOrder(true);
      };

      const handleAdd = () => {
        setCurso((prevCurso) => {
          const currentDocumento = prevCurso.documentos.find(
            (img) => img._id === cell,
          );
          if (
            !currentDocumento ||
            currentDocumento.order === prevCurso.documentos.length - 1
          )
            return prevCurso;

          const newOrder = currentDocumento.order + 1;
          const imageToSwap = prevCurso.documentos.find(
            (img) => img.order === newOrder,
          );

          return {
            ...prevCurso,
            documentos: prevCurso.documentos.map((image) => {
              if (image._id === cell) {
                return { ...image, order: newOrder };
              }
              if (imageToSwap && image._id === imageToSwap._id) {
                return { ...image, order: currentDocumento.order };
              }
              return image;
            }),
          };
        });
        setRefreshOrder(true);
      };

      return (
        <>
          <Tooltip title="Ver documento">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                const doc = curso?.documentos.find((item) => item._id === cell);
                setSelectedDocument(doc);
                setOpenDocumentModal(true);
              }}
            >
              <Visibility />
            </Button>
          </Tooltip>
          {user?.role === "admin" && (
            <>
              <Tooltip title={"Up"}>
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={handleSubtract}
                  disabled={elem?.order === 0}
                >
                  <KeyboardArrowUp />
                </Button>
              </Tooltip>
              <Tooltip title={"Down"}>
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={handleAdd}
                  disabled={elem?.order === curso?.documentos?.length - 1}
                >
                  <KeyboardArrowDown />
                </Button>
              </Tooltip>
              <Tooltip title="Edit">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    history.push(
                      "/edit-curso/" + cursoId + "/edit-documento/" + cell,
                    );
                  }}
                >
                  <EditIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setDocumentoId(cell);
                    setOpenConfirmDialog(5);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Tooltip>
            </>
          )}
        </>
      );
    }

    const columns = [
      { dataField: "title", text: "Título", sort: true },
      { dataField: "type", text: "Tipo", sort: true },
      { dataField: "url", text: "Archivo", sort: true },
      ...(isReadonly
        ? []
        : [{ dataField: "id", text: "", formatter: buttonFormatter }]),
    ];

    return (
      <>
        {!isReadonly && (
          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              onClick={() =>
                history.push("/edit-curso/" + cursoId + "/edit-documento")
              }
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </div>
        )}
        {!refreshOrder && (
          <Table
            data={getData()}
            columns={columns}
            pageKey={`curso-${cursoId}-documentos`}
            disablePaginationPersistence={true}
          />
        )}
      </>
    );
  };

  // Función para limpiar HTML y convertir entidades HTML a texto
  const stripHTML = (html) => {
    if (!html) return "";

    // Crear un elemento temporal para extraer el texto
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;

    // Obtener el texto sin HTML
    let text = tmp.textContent || tmp.innerText || "";

    // Limpiar espacios múltiples y saltos de línea
    text = text.replace(/\s+/g, " ").trim();

    return text;
  };

  // Función para generar URL amigable desde un texto
  const generateSlug = (text) => {
    if (!text) return "";

    // Limpiar HTML primero
    let slug = stripHTML(text);

    // Convertir a minúsculas
    slug = slug.toLowerCase();

    // Reemplazar caracteres especiales y acentos
    slug = slug
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Eliminar diacríticos
      .replace(/[^a-z0-9\s-]/g, "") // Eliminar caracteres especiales
      .replace(/\s+/g, "-") // Reemplazar espacios con guiones
      .replace(/-+/g, "-") // Reemplazar múltiples guiones con uno solo
      .replace(/^-|-$/g, ""); // Eliminar guiones al inicio y final

    return slug;
  };

  const renderContentEnlace = () => {
    const handleGenerateSEO = async () => {
      if (!languages || languages.length === 0) {
        alertError({
          customMessage: "No hay idiomas disponibles para generar el SEO",
        });
        return;
      }

      // Obtener información del curso para generar el SEO
      const cursoInfo = {
        titulo: curso && curso.titulo ? curso.titulo : {},
        descripcion: curso && curso.desc ? curso.desc : {},
        breve: curso && curso.breve ? curso.breve : {},
        lugar: curso && curso.lugar ? curso.lugar : {},
      };

      try {
        // Mostrar mensaje de carga
        alertSuccess({
          title: "Generando SEO...",
          customMessage:
            "Por favor espera mientras se genera el SEO para todos los idiomas",
        });

        // Generar SEO para cada idioma
        const seoData = {};

        for (const lang of languages) {
          const langCode = lang.isocode;
          if (!langCode) continue;

          // Preparar contexto del curso en el idioma actual con validaciones
          const titulo =
            cursoInfo.titulo && cursoInfo.titulo[langCode]
              ? cursoInfo.titulo[langCode]
              : cursoInfo.titulo && cursoInfo.titulo["es"]
              ? cursoInfo.titulo["es"]
              : "";
          const descripcion =
            cursoInfo.desc && cursoInfo.desc[langCode]
              ? cursoInfo.desc[langCode]
              : cursoInfo.desc && cursoInfo.desc["es"]
              ? cursoInfo.desc["es"]
              : "";
          const breve =
            cursoInfo.breve && cursoInfo.breve[langCode]
              ? cursoInfo.breve[langCode]
              : cursoInfo.breve && cursoInfo.breve["es"]
              ? cursoInfo.breve["es"]
              : "";
          const lugar =
            cursoInfo.lugar && cursoInfo.lugar[langCode]
              ? cursoInfo.lugar[langCode]
              : cursoInfo.lugar && cursoInfo.lugar["es"]
              ? cursoInfo.lugar["es"]
              : "";

          // Limpiar HTML de los textos
          const tituloLimpio = stripHTML(titulo);
          const descripcionLimpia = stripHTML(descripcion);
          const breveLimpio = stripHTML(breve);

          // Generar título SEO (máximo 60 caracteres)
          const tituloSEO =
            tituloLimpio && tituloLimpio.length > 0
              ? tituloLimpio.length > 60
                ? tituloLimpio.substring(0, 57) + "..."
                : tituloLimpio
              : `Curso ${curso && curso.code ? curso.code : ""}`;

          // Generar descripción SEO (máximo 160 caracteres)
          let descripcionSEO = "";
          if (breveLimpio && breveLimpio.length > 0) {
            descripcionSEO =
              breveLimpio.length > 160
                ? breveLimpio.substring(0, 157) + "..."
                : breveLimpio;
          } else if (descripcionLimpia && descripcionLimpia.length > 0) {
            descripcionSEO =
              descripcionLimpia.length > 160
                ? descripcionLimpia.substring(0, 157) + "..."
                : descripcionLimpia;
          }

          if (!descripcionSEO || descripcionSEO.length === 0) {
            descripcionSEO = `Información sobre el curso ${tituloSEO}`;
          }

          // Generar URL amigable
          const urlAmigable = generateSlug(tituloLimpio || tituloSEO);

          seoData[langCode] = {
            enlace: urlAmigable,
            tituloEnlace: tituloSEO,
            descripcionEnlace: descripcionSEO,
          };
        }

        // Actualizar el curso con el SEO generado
        setCurso((prevCurso) => ({
          ...prevCurso,
          enlace: {
            ...prevCurso.enlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.enlace,
              ]),
            ),
          },
          tituloEnlace: {
            ...prevCurso.tituloEnlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.tituloEnlace,
              ]),
            ),
          },
          descripcionEnlace: {
            ...prevCurso.descripcionEnlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.descripcionEnlace,
              ]),
            ),
          },
        }));

        alertSuccess({
          title: "SEO generado!",
          customMessage: `Se ha generado el SEO para ${
            Object.keys(seoData).length
          } idiomas`,
        });
      } catch (error) {
        console.error("Error generando SEO:", error);
        alertError({
          error: error,
          customMessage: "No se ha podido generar el SEO",
        });
      }
    };

    return (
      <>
        {!isReadonly && (
          <div className="d-flex justify-content-end mb-3">
            <Button
              variant="contained"
              onClick={handleGenerateSEO}
              startIcon={<FlashOn />}
              style={{
                backgroundColor: "#9c27b0",
                color: "#fff",
              }}
            >
              GENERAR
            </Button>
          </div>
        )}
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContentEnlace}
        />
      </>
    );
  };

  const renderContentInscripciones = () => {
    function getData() {
      let data = [];
      const inscripcionesCurso = curso?.inscripciones;
      if (!inscripcionesCurso || !Array.isArray(inscripcionesCurso)) {
        console.log("Inscripciones: No hay inscripciones o no es un array");
        return [];
      }

      // Si users no está disponible, retornar array vacío pero loguear
      if (!users || !Array.isArray(users)) {
        console.log("Inscripciones: Users no está disponible aún");
        return [];
      }

      console.log(
        `Inscripciones: Procesando ${inscripcionesCurso.length} inscripciones con ${users.length} usuarios disponibles`,
      );

      let skippedNoId = 0;
      let skippedNoUser = 0;
      let skippedUserNotFound = 0;

      for (const insc of inscripcionesCurso) {
        // Validaciones estrictas
        if (!insc || typeof insc !== "object") continue;
        if (!insc._id) {
          skippedNoId++;
          continue; // Saltar si no tiene _id
        }

        // Convertir _id a string para validación
        const inscripcionId = String(insc._id);
        if (
          !inscripcionId ||
          inscripcionId.trim() === "" ||
          inscripcionId === "null" ||
          inscripcionId === "undefined"
        ) {
          skippedNoId++;
          continue;
        }

        // Buscar usuario (normalizar IDs a string para comparación)
        let user = null;
        if (insc.user) {
          user = users.find((x) => {
            if (!x || !x._id) return false;
            const userId = String(x._id);
            const inscUserId = String(insc.user);
            return userId === inscUserId;
          });
        }

        // Si no se encuentra el usuario, crear elemento con datos básicos de la inscripción
        if (!user || typeof user !== "object") {
          skippedUserNotFound++;
          // Mostrar la inscripción aunque no tenga usuario asociado
          let elem = {
            createdAt: insc.createdAt || null,
            pagado: insc.pagado || "",
            aprovado: insc.aprovado || "",
            nRegistro: insc.nRegistro || "",
            userType: "(Usuario no encontrado)",
            nSocio: "",
            fullName: "(Usuario no encontrado)",
            email: "",
            certificado: insc.certificado || "",
            fechaPago: insc.fechaPago || null,
            codigoPago: resolveInscripcionCodigoPago(insc),
            pagoDisplay: "---",
            obs: insc.obs || "",
            pendiente: true,
            estado: insc.active ? "Activo" : "Inactivo",
            id: inscripcionId,
          };

          if (
            elem.id &&
            elem.id.trim() !== "" &&
            elem.id !== "null" &&
            elem.id !== "undefined"
          ) {
            data.push(elem);
          }
          continue;
        }

        // Crear elemento con datos completos del usuario
        let elem = {
          createdAt: insc.createdAt || null,
          pagado: insc.pagado || "",
          aprovado: insc.aprovado || "",
          nRegistro: insc.nRegistro || "",
          userType:
            userTypes.find(
              (x) => x && x._id && String(x._id) === String(user.type),
            )?.title || "",
          nSocio: user.nAso || "",
          fullName: `${user.fullName || ""} ${user.apellido1 ||
            ""} ${user.apellido2 || ""}`.trim(),
          email: user.email || "",
          dni: user.dni || "",
          certificado: insc.certificado || "",
          fechaPago: insc.fechaPago || null,
          codigoPago: resolveInscripcionCodigoPago(insc),
          pagoDisplay: formatPagoDisplay(insc.paymentInfo, true),
          obs: insc.obs || "",
          pendiente: true, //adaptar logica correcta
          estado: insc.active ? "Activo" : "Inactivo",
          id: inscripcionId, // Usar el ID ya convertido a string
        };

        // Solo agregar si tiene id válido (no vacío)
        if (
          elem.id &&
          elem.id.trim() !== "" &&
          elem.id !== "null" &&
          elem.id !== "undefined"
        ) {
          data.push(elem);
        }
      }

      console.log(
        `Inscripciones: Resultado - ${data.length} elementos válidos, ${skippedNoId} sin _id, ${skippedUserNotFound} sin usuario encontrado`,
      );

      // Filtrado final estricto: solo elementos con id válido
      return data
        .filter((item) => {
          return (
            item &&
            typeof item === "object" &&
            item.id &&
            typeof item.id === "string" &&
            item.id.trim() !== ""
          );
        })
        .sort(
          (a, b) => parseInt(a.certificado, 10) - parseInt(b.certificado, 10),
        );
    }
    function buttonFormatter(cell) {
      if (isReadonly) return null; // No mostrar botones si es consultor

      const elem = curso?.inscripciones.find((item) => item._id === cell);
      return (
        <>
          {(user?.role === "admin" || user.role === "gestor") && (
            <>
              <Tooltip title="Enviar recordatorio">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setInscripcionIdForRecordatorio(cell);
                    setOpenConfirmDialog(7);
                  }}
                >
                  <Mail />
                </Button>
              </Tooltip>
              <Tooltip title="Cambiar estado de aprobación">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={(event) => {
                    event.stopPropagation();
                    setAnchorElAprovado(event.currentTarget);
                    setSelectedInscripcionForAprovado(elem);
                  }}
                >
                  {elem?.aprovado === "si" ? (
                    <Check style={{ color: "green" }} />
                  ) : elem?.aprovado === "no" ? (
                    <Check style={{ color: "red" }} />
                  ) : (
                    <Check style={{ color: "gray" }} />
                  )}
                </Button>
              </Tooltip>
              <Tooltip title="Edit">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    const inscripcion = curso?.inscripciones.find(
                      (item) => item._id === cell,
                    );
                    const user = users.find((x) => x._id === inscripcion?.user);
                    setCurrentInscripcion(
                      inscripcion || {
                        pagado: "",
                        aprovado: "sin asignar",
                        fechaPago: "",
                        codigoPago: "",
                        nRegistro: "",
                        certificado: "",
                        obs: "",
                        active: true,
                      },
                    );
                    setSelectedUserInscripcion(user || null);
                    // Inicializar los datos editados del usuario con una copia
                    setEditedUserData(user ? { ...user } : null);
                    setIsCreatingNewUser(false);
                    setOpenInscripcionModal(true);
                  }}
                >
                  <EditIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setInscriptionId(cell);
                    setOpenConfirmDialog(3);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Tooltip>
            </>
          )}
        </>
      );
    }

    const columns = [
      { dataField: "estado", text: "Estado", sort: true },
      { dataField: "pagado", text: "Pagado", sort: true },
      { dataField: "pagoDisplay", text: "Pago", sort: true },
      { dataField: "aprovado", text: "Aprovado", sort: true },
      { dataField: "userType", text: "Tipo de Usuario", sort: true },
      { dataField: "nSocio", text: "Nº Socio", sort: true },
      { dataField: "fullName", text: "Nombre y Apellidos", sort: true },
      { dataField: "email", text: "Email", sort: true },
      { dataField: "certificado", text: "Certificado", sort: true },
      {
        dataField: "createdAt",
        text: "Fecha de inscripción",
        sort: true,
        formatter: dateFormatter,
      },
      {
        dataField: "fechaPago",
        text: "Fecha de pago",
        sort: true,
        formatter: dateFormatter,
      },
      { dataField: "codigoPago", text: "Código pago", sort: true },
      { dataField: "obs", text: "Observaciones", sort: true },
      ...(isReadonly
        ? []
        : [{ dataField: "id", text: "", formatter: buttonFormatter }]),
    ];
    return (
      <>
        {!isReadonly && (
          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              onClick={() => {
                setCurrentInscripcion({
                  pagado: "",
                  aprovado: "sin asignar",
                  fechaPago: "",
                  codigoPago: "",
                  nRegistro: "",
                  certificado: "",
                  obs: "",
                  active: true,
                });
                setSelectedUserInscripcion(null);
                setEditedUserData(null);
                setIsCreatingNewUser(false);
                setOpenInscripcionModal(true);
              }}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
                marginRight: "10px",
              }}
            >
              Añadir nuevo
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setOpenConfirmDialog(8);
              }}
              startIcon={<Mail />}
              style={{
                backgroundColor: "#2196f3",
                color: "#fff",
                marginRight: "10px",
              }}
            >
              RECORDATORIO
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                try {
                  // Obtener todos los datos de inscripciones
                  const tableData = getData() || [];

                  if (tableData.length === 0) {
                    alertError({
                      customMessage: "No hay inscripciones para exportar",
                    });
                    return;
                  }

                  // Preparar datos para Excel
                  const excelData = tableData.map((item) => ({
                    "Fecha de inscripción": item.createdAt
                      ? new Date(item.createdAt).toLocaleDateString("es-ES")
                      : "",
                    Estado: item.estado || "",
                    Pagado: item.pagado || "",
                    Pago: item.pagoDisplay || "---",
                    Aprovado: item.aprovado || "",
                    "Tipo de Usuario": item.userType || "",
                    "Nº Socio": item.nSocio || "",
                    "Nombre y Apellidos": item.fullName || "",
                    Email: item.email || "",
                    DNI: item.dni || "",
                    Certificado: item.certificado || "",
                    "Fecha de pago": item.fechaPago
                      ? new Date(item.fechaPago).toLocaleDateString("es-ES")
                      : "",
                    "Código pago": item.codigoPago || "",
                    Observaciones: item.obs || "",
                  }));

                  // Crear workbook y worksheet
                  const worksheet = XLSX.utils.json_to_sheet(excelData);
                  const workbook = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Inscripciones",
                  );

                  // Generar nombre del archivo con fecha
                  const fecha = new Date().toISOString().split("T")[0];
                  const cursoCode = curso?.code || cursoId || "curso";
                  const fileName = `inscripciones_${cursoCode}_${fecha}.xlsx`;

                  // Descargar el archivo
                  XLSX.writeFile(workbook, fileName);

                  alertSuccess({
                    title: "Exportado!",
                    customMessage: `Se ha exportado ${tableData.length} inscripciones a Excel`,
                  });
                } catch (error) {
                  console.error("Error exportando a Excel:", error);
                  alertError({
                    error: error,
                    customMessage: "No se ha podido exportar a Excel",
                  });
                }
              }}
              startIcon={<GetApp />}
              style={{
                backgroundColor: "#4caf50",
                color: "#fff",
              }}
            >
              EXPORTAR XLSX
            </Button>
          </div>
        )}
        {!refreshInscritos &&
          (() => {
            try {
              const tableData = getData() || [];
              // Validación final: asegurar que todos los elementos tengan id válido
              const validData = tableData.filter(
                (item) =>
                  item &&
                  item.id &&
                  typeof item.id === "string" &&
                  item.id.trim() !== "",
              );
              return (
                <Table
                  data={validData}
                  columns={columns}
                  pageKey={`curso-${cursoId}-inscripciones`}
                  disablePaginationPersistence={true}
                />
              );
            } catch (error) {
              console.error("Error al obtener datos de inscripciones:", error);
              return (
                <Table
                  data={[]}
                  columns={columns}
                  pageKey={`curso-${cursoId}-inscripciones`}
                  disablePaginationPersistence={true}
                />
              );
            }
          })()}
        {/* Menú desplegable para cambiar estado de aprobación */}
        <Menu
          anchorEl={anchorElAprovado}
          open={Boolean(anchorElAprovado)}
          onClose={() => {
            setAnchorElAprovado(null);
            setSelectedInscripcionForAprovado(null);
          }}
        >
          {selectedInscripcionForAprovado &&
            (() => {
              const currentState =
                selectedInscripcionForAprovado?.aprovado || "sin asignar";
              const options = [];

              if (currentState === "si") {
                options.push({ value: "no", label: "Cambiar a No aprobado" });
                options.push({
                  value: "sin asignar",
                  label: "Cambiar a Sin asignar",
                });
              } else if (currentState === "no") {
                options.push({ value: "si", label: "Cambiar a Aprobado" });
                options.push({
                  value: "sin asignar",
                  label: "Cambiar a Sin asignar",
                });
              } else {
                options.push({ value: "si", label: "Cambiar a Aprobado" });
                options.push({ value: "no", label: "Cambiar a No aprobado" });
              }

              return options.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => {
                    setNewAprovadoValue(option.value);
                    setInscriptionId(selectedInscripcionForAprovado);
                    setAnchorElAprovado(null);
                    setSelectedInscripcionForAprovado(null);
                    setOpenConfirmDialog(6);
                  }}
                >
                  {option.label}
                </MenuItem>
              ));
            })()}
        </Menu>
      </>
    );
  };

  const renderContentDocentes = () => {
    function getData() {
      let data = [];
      const docentesCurso = curso?.docentes;
      if (!docentesCurso || !Array.isArray(docentesCurso)) return [];
      if (!users || !Array.isArray(users)) return []; // Verificar que users esté disponible

      for (const docente of docentesCurso) {
        // Validaciones estrictas
        if (!docente || typeof docente !== "object") continue;
        if (!docente._id) continue; // Saltar si no tiene _id (puede ser ObjectId o string)

        // Convertir _id a string para comparación
        const docenteId = String(docente._id);
        if (
          !docenteId ||
          docenteId.trim() === "" ||
          docenteId === "null" ||
          docenteId === "undefined"
        )
          continue;

        // Buscar usuario (normalizar IDs a string para comparación)
        const user = users.find((x) => {
          if (!x || !x._id) return false;
          const userId = String(x._id);
          const docenteUserId = docente.docente
            ? String(docente.docente)
            : null;
          return userId === docenteUserId;
        });

        if (!user || typeof user !== "object") continue; // Saltar si no se encuentra el usuario

        // Crear elemento solo si todo es válido (nombre completo = nombre + apellidos)
        const fullNameComplete = user.fullName;
        // En el modelo existen ambos campos: `dni` y `nif`. Para docentes tratamos ambos como NIF.
        const nif = (user.dni || user.nif || "").toString();
        let elem = {
          createdAt: docente.createdAt || null,
          certificado: docente.certificado || "",
          certificadoDirector: docente.certificadoDirector || "",
          nRegistro: (docente.nRegistro || "").toString(),
          fullName: fullNameComplete,
          apellido1: (user.apellido1 || "").toString(),
          apellido2: (user.apellido2 || "").toString(),
          dni: nif,
          email: (user.email || "").toString(),
          telefono: (user.telefono || "").toString(),
          obs: (docente.obs || "").toString(),
          estado: docente.active ? "Activo" : "Inactivo",
          esDirector: !!docente.esDirector,
          aprovado: docente.aprovado || "Sin asignar",
          id: docenteId, // Usar el ID ya convertido a string
        };

        // Solo agregar si tiene id válido (no vacío)
        if (
          elem.id &&
          elem.id.trim() !== "" &&
          elem.id !== "null" &&
          elem.id !== "undefined"
        ) {
          data.push(elem);
        }
      }

      // Filtrado final estricto: solo elementos con id válido
      return data.filter((item) => {
        return (
          item &&
          typeof item === "object" &&
          item.id &&
          typeof item.id === "string" &&
          item.id.trim() !== ""
        );
      });
    }
    const handleToggleDirector = (docenteRowId) => {
      setCurso((prevCurso) => {
        const docentesCurso = prevCurso?.docentes;
        if (!docentesCurso || !Array.isArray(docentesCurso)) return prevCurso;
        const docente = docentesCurso.find(
          (item) => String(item._id) === String(docenteRowId),
        );
        if (!docente) return prevCurso;
        const newEsDirector = !docente.esDirector;
        return {
          ...prevCurso,
          docentes: docentesCurso.map((d) =>
            String(d._id) === String(docenteRowId)
              ? { ...d, esDirector: newEsDirector }
              : d,
          ),
        };
      });
    };

    function buttonFormatter(cell) {
      if (isReadonly) return null; // No mostrar botones si es consultor

      const elem = curso?.docentes.find(
        (item) => String(item._id) === String(cell),
      );
      const esDirector = elem?.esDirector === true;
      return (
        <>
          {(user?.role === "admin" || user.role === "gestor") && (
            <>
              <Tooltip
                title={
                  esDirector
                    ? "Director (doble certificado). Clic para quitar. Los cambios se guardan al pulsar Guardar."
                    : "Marcar como director (doble certificado). Los cambios se guardan al pulsar Guardar."
                }
              >
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => handleToggleDirector(cell)}
                >
                  {esDirector ? (
                    <StarIcon style={{ color: "#f3691a" }} />
                  ) : (
                    <StarBorderIcon />
                  )}
                </Button>
              </Tooltip>
              <Tooltip title="Edit">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    const docente = curso?.docentes.find(
                      (item) => String(item._id) === String(cell),
                    );
                    const user = users.find((x) => x._id === docente?.docente);
                    setCurrentDocente(
                      docente || {
                        obs: "",
                        active: true,
                        certificado: "",
                        certificadoDirector: "",
                        esDirector: false,
                        aprovado: "Sin asignar",
                      },
                    );
                    setSelectedUserDocente(user || null);
                    setIsCreatingNewUserDocente(false);
                    setOpenDocenteModal(true);
                  }}
                >
                  <EditIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setDocenteId(cell);
                    setOpenConfirmDialog(4);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Tooltip>
            </>
          )}
        </>
      );
    }

    const columns = [
      {
        dataField: "createdAt",
        text: "Fecha de inscripción",
        sort: true,
        formatter: dateFormatter,
      },
      { dataField: "nRegistro", text: "Nº registro", sort: true },
      {
        dataField: "certificado",
        text: "Certificado",
        sort: true,
        formatter: (cell, row) => {
          const cert = (row.certificado || "").toString().trim();
          const certDir = (row.certificadoDirector || "").toString().trim();
          if (row.esDirector && certDir) {
            return cert ? `${cert} | ${certDir}` : `${certDir}`;
          }
          return cert || "";
        },
      },
      {
        dataField: "esDirector",
        text: "Director (puede haber varios)",
        sort: true,
        formatter: (cell) => (cell ? "Sí" : ""),
      },
      {
        dataField: "aprovado",
        text: "Aprobado",
        sort: true,
      },
      { dataField: "fullName", text: "Nombre", sort: true },
      { dataField: "apellido1", text: "Apellido 1", sort: true },
      { dataField: "apellido2", text: "Apellido 2", sort: true },
      { dataField: "dni", text: "NIF", sort: true },
      { dataField: "email", text: "Email", sort: true },
      { dataField: "telefono", text: "Teléfono", sort: true },
      { dataField: "obs", text: "Observaciones", sort: true },
      ...(isReadonly
        ? []
        : [{ dataField: "id", text: "", formatter: buttonFormatter }]),
    ];
    return (
      <>
        {!isReadonly && (
          <div
            className="d-flex justify-content-end align-items-center"
            style={{ gap: 10 }}
          >
            <Button
              variant="contained"
              onClick={() => {
                try {
                  const tableData = getData() || [];
                  if (tableData.length === 0) {
                    alertError({
                      customMessage: "No hay docentes para exportar",
                    });
                    return;
                  }
                  const excelData = tableData.map((item) => ({
                    "Fecha de inscripción": item.createdAt
                      ? new Date(item.createdAt).toLocaleDateString("es-ES")
                      : "",
                    "Nº registro": item.nRegistro || "",
                    Certificado: item.certificado || "",
                    "Certificado director": item.certificadoDirector || "",
                    Director: item.esDirector ? "Sí" : "",
                    Aprobado: item.aprovado || "",
                    Nombre: item.fullName || "",
                    "Apellido 1": item.apellido1 || "",
                    "Apellido 2": item.apellido2 || "",
                    NIF: item.dni || "",
                    Email: item.email || "",
                    Teléfono: item.telefono || "",
                    Observaciones: item.obs || "",
                    Estado: item.estado || "",
                  }));
                  const worksheet = XLSX.utils.json_to_sheet(excelData);
                  const workbook = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(workbook, worksheet, "Docentes");
                  const fecha = new Date().toISOString().split("T")[0];
                  const cursoCode = curso?.code || cursoId || "curso";
                  const fileName = `docentes_${cursoCode}_${fecha}.xlsx`;
                  XLSX.writeFile(workbook, fileName);
                  alertSuccess({
                    title: "Exportado",
                    customMessage: `Se ha exportado ${tableData.length} docentes a Excel`,
                  });
                } catch (error) {
                  console.error("Error exportando docentes a Excel:", error);
                  alertError({
                    error: error,
                    customMessage:
                      "No se ha podido exportar los docentes a Excel",
                  });
                }
              }}
              startIcon={<GetApp />}
              style={{
                backgroundColor: "#4caf50",
                color: "#fff",
              }}
            >
              Exportar los docentes en excel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setCurrentDocente({
                  obs: "",
                  active: true,
                  nRegistro: "",
                  certificado: "",
                  certificadoDirector: "",
                  esDirector: false,
                  aprovado: "Sin asignar",
                });
                setSelectedUserDocente(null);
                setIsCreatingNewUserDocente(false);
                setOpenDocenteModal(true);
                setDocenteSearchText("");
                setDocenteSearchFiltered("");
              }}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </div>
        )}
        {(() => {
          try {
            const tableData = getData() || [];
            // Validación final: asegurar que todos los elementos tengan id válido
            const validData = tableData.filter(
              (item) =>
                item &&
                item.id &&
                typeof item.id === "string" &&
                item.id.trim() !== "",
            );
            return (
              <Table
                data={validData}
                columns={columns}
                pageKey={`curso-${cursoId}-docentes`}
                disablePaginationPersistence={true}
              />
            );
          } catch (error) {
            console.error("Error al obtener datos de docentes:", error);
            return (
              <Table
                data={[]}
                columns={columns}
                pageKey={`curso-${cursoId}-docentes`}
                disablePaginationPersistence={true}
              />
            );
          }
        })()}
      </>
    );
  };

  const renderContentValoraciones = () => {
    const columns = [
      {
        dataField: "validated",
        text: "Estado",
        formatter: (cell, row) => {
          const validated = row.validated;
          const isPending = !validated;
          return (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                color: validated ? "#28a745" : "#dc3545",
                fontWeight: 500,
              }}
            >
              {isPending && <AlertTriangle size={18} />}
              {validated ? "Validado" : "Pendiente"}
            </span>
          );
        },
      },
      {
        dataField: "stars",
        text: "Estrellas",
        formatter: (cell) => `${cell} / 5`,
      },
      {
        dataField: "user",
        text: "Usuario",
        formatter: (cell) => {
          if (!cell) return "-";
          const name = [cell.fullName, cell.apellido1, cell.apellido2]
            .filter(Boolean)
            .join(" ");
          return name || cell.email || "-";
        },
      },
      {
        dataField: "comment",
        text: "Comentario",
        formatter: (cell) => {
          if (!cell) return "-";
          const s = String(cell);
          const truncated = s.slice(0, 80) + (s.length > 80 ? "…" : "");
          const isLong = s.length > 80;
          return (
            <span
              style={{
                cursor: isLong ? "pointer" : "default",
                borderBottom: isLong ? "1px dotted rgba(0,0,0,0.35)" : "none",
              }}
              onClick={(e) => {
                if (!isLong) return;
                const rect = e.currentTarget.getBoundingClientRect();
                const panelWidth = 420;
                const panelMaxHeight = 360;
                const left = Math.max(
                  8,
                  Math.min(rect.left, window.innerWidth - panelWidth - 8),
                );
                const preferredTop = rect.bottom + 8;
                const topFitsBelow =
                  preferredTop + panelMaxHeight <= window.innerHeight - 8;
                const top = topFitsBelow
                  ? preferredTop
                  : Math.max(8, rect.top - 8 - panelMaxHeight);
                setValoracionCommentModal({
                  open: true,
                  text: s,
                  anchorLeft: left,
                  anchorTop: top,
                });
              }}
            >
              {truncated}
            </span>
          );
        },
      },
      {
        dataField: "createdAt",
        text: "Fecha",
        formatter: (cell) => (cell ? dateFormatter(cell) : "-"),
      },
      {
        dataField: "_id",
        text: "Acciones",
        formatter: (cell, row) => {
          if (isReadonly) return null;
          if (user?.role !== "admin" && user?.role !== "gestor") return null;
          return (
            <>
              <Tooltip
                title={
                  row.validated ? "No validar (quitar validación)" : "Validar"
                }
              >
                <Button
                  size="small"
                  style={buttonsStyle}
                  onClick={() => {
                    setCursoRatingValidated(cell, !row.validated)
                      .then(() => {
                        setRefreshRatings((r) => r + 1);
                        alertSuccess({
                          customMessage: row.validated
                            ? "Validación quitada."
                            : "Valoración validada.",
                        });
                      })
                      .catch((err) => {
                        alertError({
                          error: err,
                          customMessage: "Error al actualizar.",
                        });
                      });
                  }}
                >
                  {row.validated ? (
                    <Check style={{ color: "#28a745" }} />
                  ) : (
                    <Check style={{ color: "#dc3545" }} />
                  )}
                </Button>
              </Tooltip>
              <Tooltip title="Borrar comentario">
                <Button
                  size="small"
                  style={buttonsStyle}
                  onClick={() => {
                    setRatingIdToDelete(cell);
                    setOpenConfirmDialog(9);
                  }}
                >
                  <Delete style={{ color: "#dc3545" }} />
                </Button>
              </Tooltip>
            </>
          );
        },
      },
    ];

    const rowClasses = (row) =>
      row.validated ? "valoracion-validada" : "valoracion-pendiente";

    return (
      <>
        <style>
          {`.valoracion-validada { background-color: rgba(40, 167, 69, 0.12) !important; }
           .valoracion-pendiente { background-color: rgba(220, 53, 69, 0.12) !important; }`}
        </style>

        <Dialog
          open={valoracionCommentModal.open}
          disableScrollLock
          hideBackdrop
          onClose={() => {
            setValoracionCommentModal((prev) => ({ ...prev, open: false }));
          }}
          PaperProps={{
            style: {
              position: "fixed",
              left: valoracionCommentModal.anchorLeft,
              top: valoracionCommentModal.anchorTop,
              margin: 0,
              maxWidth: 420,
              maxHeight: "min(50vh, 360px)",
              overflow: "auto",
              pointerEvents: "auto",
            },
          }}
        >
          <DialogTitle style={{ paddingBottom: 8 }}>
            Comentario completo
          </DialogTitle>
          <DialogContent style={{ paddingTop: 0 }}>
            <Typography
              component="div"
              variant="body2"
              style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              {valoracionCommentModal.text}
            </Typography>
          </DialogContent>
        </Dialog>

        {!loadingRatings && (
          <Table
            data={ratingsList}
            columns={columns}
            pageKey={`curso-${cursoId}-valoraciones`}
            rowClasses={rowClasses}
            disablePaginationPersistence={true}
          />
        )}
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () =>
              history.push(
                isPersonalizadaBackoffice
                  ? "/formaciones-personalizadas"
                  : "/cursos",
              ),
            onSave: saveCurso,
            onDelete: () => setOpenConfirmDialog(1),
            showDelete: !!cursoId,
            setObj: setCurso,
            obj: curso,
          })}
          <CardHeader
            title={
              isPersonalizadaBackoffice
                ? isReadonly
                  ? "Ver formación personalizada"
                  : "Editar formación personalizada"
                : isReadonly
                ? "Ver Curso"
                : "Editar Curso"
            }
          ></CardHeader>
          <CardBody>
            {!isPersonalizadaBackoffice ? (
              <MultiTabBlock
                activeTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                  {
                    enable: true,
                    title: "Datos Generales",
                    renderContent: renderContentDatosGenerales,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "Precios",
                    renderContent: renderContentPricing,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "Documentos",
                    renderContent: renderContentDocument,
                  },

                  {
                    enable: cursoId !== undefined,
                    title: "Inscripciones",
                    renderContent: renderContentInscripciones,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "Docentes",
                    renderContent: renderContentDocentes,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "Valoraciones",
                    renderContent: renderContentValoraciones,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "SEO",
                    renderContent: renderContentEnlace,
                  },
                ]}
              />
            ) : (
              <MultiTabBlock
                activeTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                  {
                    enable: true,
                    title: "Datos Generales",
                    renderContent: renderContentDatosGenerales,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "Valoraciones",
                    renderContent: renderContentValoraciones,
                  },
                  {
                    enable: cursoId !== undefined,
                    title: "SEO",
                    renderContent: renderContentEnlace,
                  },
                ]}
              />
            )}
          </CardBody>
        </Card>

        {!isReadonly && (
          <>
            {cursoId && (
              <>
                <ConfirmDialog
                  title={"Are you sure you want to delete this curso?"}
                  open={openConfirmDialog === 1}
                  setOpen={setOpenConfirmDialog}
                  onConfirm={() => {
                    deleteCurso(cursoId)
                      .then((res) => {
                        if (res.status === 204 || res.status === 200) {
                          alertSuccess({
                            title: "Deleted!",
                            customMessage: "Curso deleted successfully",
                          });
                          history.push("/cursos");
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage: "Could not delete curso.",
                        });
                      });
                  }}
                />
                <ConfirmDialog
                  title={"Are you sure you want to delete this price?"}
                  open={openConfirmDialog === 2}
                  setOpen={setOpenConfirmDialog}
                  onConfirm={() => {
                    setCurso({
                      ...curso,
                      pricing: curso?.pricing?.filter((x) => x._id !== priceId),
                    });
                  }}
                />
                <ConfirmDialog
                  title={"Are you sure you want to delete this document?"}
                  open={openConfirmDialog === 5}
                  setOpen={setOpenConfirmDialog}
                  onConfirm={() => {
                    handleDeleteMedia(documentoId);
                  }}
                />
                {/* Modal para ver documento */}
                <Dialog
                  fullWidth={true}
                  maxWidth="lg"
                  open={openDocumentModal}
                  onClose={() => setOpenDocumentModal(false)}
                  aria-labelledby="document-dialog"
                >
                  <DialogTitle id="document-dialog">
                    {selectedDocument
                      ? getNonEmpty(selectedDocument.title)
                      : "Documento"}
                  </DialogTitle>
                  <DialogContent>
                    {selectedDocument &&
                      (() => {
                        const documentUrl = `${SERVER_URL}/${selectedDocument.url}`;
                        const fileType = getFileType(documentUrl);
                        const isVideo =
                          !documentUrl.startsWith("blob") &&
                          fileType === "video";
                        const isImage = fileType === "image";

                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {isVideo ? (
                              <video
                                className="preview-video"
                                controls
                                style={{ width: "100%", maxHeight: "70vh" }}
                              >
                                <source src={documentUrl} />
                              </video>
                            ) : isImage ? (
                              <img
                                src={documentUrl}
                                alt={getNonEmpty(selectedDocument.title)}
                                style={{ maxWidth: "100%", maxHeight: "70vh" }}
                              />
                            ) : (
                              <embed
                                src={documentUrl}
                                style={{
                                  width: "100%",
                                  height: "70vh",
                                  minHeight: "500px",
                                }}
                                type={
                                  fileType === "file"
                                    ? "application/pdf"
                                    : undefined
                                }
                              />
                            )}
                          </div>
                        );
                      })()}
                  </DialogContent>
                  <DialogActions>
                    {selectedDocument && (
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<GetApp />}
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = `${SERVER_URL}/${selectedDocument.url}`;
                          link.download =
                            selectedDocument.url.split("/").pop() ||
                            "documento";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        style={{ backgroundColor: "#f3691a", color: "white" }}
                      >
                        Descargar
                      </Button>
                    )}
                    <Button
                      variant="outlined"
                      onClick={() => setOpenDocumentModal(false)}
                      color="default"
                    >
                      Cerrar
                    </Button>
                  </DialogActions>
                </Dialog>
                <ConfirmDialog
                  title={"Are you sure you want to delete this inscription?"}
                  open={openConfirmDialog === 3}
                  setOpen={setOpenConfirmDialog}
                  onConfirm={() => {
                    setCurso({
                      ...curso,
                      inscripciones: curso?.inscripciones?.filter(
                        (x) => x._id !== inscripcionId,
                      ),
                    });
                  }}
                />
                <ConfirmDialog
                  title={"Are you sure you want to delete this docente?"}
                  open={openConfirmDialog === 4}
                  setOpen={setOpenConfirmDialog}
                  onConfirm={() => {
                    setCurso({
                      ...curso,
                      docentes: curso?.docentes?.filter(
                        (x) => x._id !== docenteId,
                      ),
                    });
                  }}
                />
                <ConfirmDialog
                  title={`¿Estás seguro de cambiar el estado de aprobación?`}
                  open={openConfirmDialog === 6}
                  setOpen={(value) => {
                    setOpenConfirmDialog(value);
                    if (!value) {
                      // Limpiar estados cuando se cierra el diálogo
                      setNewAprovadoValue(null);
                    }
                  }}
                  onConfirm={() => {
                    const currentState =
                      inscripcionId?.aprovado || "sin asignar";
                    const newState = newAprovadoValue || "sin asignar";

                    // Mapear estados a texto legible
                    const stateLabels = {
                      si: "Aprobado",
                      no: "No aprobado",
                      "sin asignar": "Sin asignar",
                    };

                    aprovarInteresado(cursoId, inscripcionId._id, newState)
                      .then((res) => {
                        if (res.status === 200) {
                          alertSuccess({
                            title: "Estado actualizado!",
                            customMessage: `El estado ha cambiado de "${stateLabels[currentState]}" a "${stateLabels[newState]}"`,
                          });
                          setRefreshInscritos(true);
                          setNewAprovadoValue(null);
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage: `No se ha podido realizar la acción.`,
                        });
                        setNewAprovadoValue(null);
                      });
                  }}
                >
                  {inscripcionId && newAprovadoValue && (
                    <div style={{ marginTop: "10px" }}>
                      <Typography variant="body2">
                        <strong>Estado actual:</strong>{" "}
                        {inscripcionId.aprovado === "si"
                          ? "Aprobado"
                          : inscripcionId.aprovado === "no"
                          ? "No aprobado"
                          : "Sin asignar"}
                      </Typography>
                      <Typography variant="body2" style={{ marginTop: "5px" }}>
                        <strong>Nuevo estado:</strong>{" "}
                        {newAprovadoValue === "si"
                          ? "Aprobado"
                          : newAprovadoValue === "no"
                          ? "No aprobado"
                          : "Sin asignar"}
                      </Typography>
                    </div>
                  )}
                </ConfirmDialog>
                <ConfirmDialog
                  title="¿Enviar recordatorio por email?"
                  open={openConfirmDialog === 7}
                  setOpen={(value) => {
                    setOpenConfirmDialog(value);
                    if (!value) {
                      setInscripcionIdForRecordatorio(null);
                    }
                  }}
                  onConfirm={() => {
                    if (inscripcionIdForRecordatorio) {
                      recordatorioInteresado(
                        cursoId,
                        inscripcionIdForRecordatorio,
                      )
                        .then((res) => {
                          alertSuccess({
                            title: "Enviado!",
                            customMessage:
                              "Recordatorio enviado por email al usuario",
                          });
                          setInscripcionIdForRecordatorio(null);
                        })
                        .catch((error) => {
                          alertError({
                            error: error,
                            customMessage:
                              "No se ha podido enviar el recordatorio",
                          });
                          setInscripcionIdForRecordatorio(null);
                        });
                    }
                  }}
                >
                  <Typography variant="body2" style={{ marginTop: "10px" }}>
                    Se enviará un email de recordatorio al usuario inscrito con
                    información sobre el curso.
                    <br />
                    <br />
                    ¿Deseas continuar?
                  </Typography>
                </ConfirmDialog>
                <ConfirmDialog
                  title="¿Enviar recordatorio por email a todos los inscritos?"
                  open={openConfirmDialog === 8}
                  setOpen={(value) => {
                    setOpenConfirmDialog(value);
                  }}
                  onConfirm={() => {
                    const inscripciones = curso?.inscripciones || [];
                    if (inscripciones.length === 0) {
                      alertError({
                        customMessage: "No hay inscripciones en este curso",
                      });
                      return;
                    }

                    // Enviar recordatorios a todos los inscritos
                    const promises = inscripciones.map((inscripcion) => {
                      if (inscripcion && inscripcion._id) {
                        return recordatorioInteresado(
                          cursoId,
                          inscripcion._id,
                        ).catch((error) => {
                          console.error(
                            `Error enviando recordatorio a inscripción ${inscripcion._id}:`,
                            error,
                          );
                          return {
                            error: true,
                            inscripcionId: inscripcion._id,
                          };
                        });
                      }
                      return Promise.resolve(null);
                    });

                    Promise.all(promises)
                      .then((results) => {
                        const successCount = results.filter(
                          (r) => r && !r.error,
                        ).length;
                        const errorCount = results.filter((r) => r && r.error)
                          .length;

                        if (errorCount === 0) {
                          alertSuccess({
                            title: "Enviados!",
                            customMessage: `Se han enviado ${successCount} recordatorios por email correctamente`,
                          });
                        } else {
                          alertError({
                            customMessage: `Se enviaron ${successCount} recordatorios correctamente, pero ${errorCount} fallaron`,
                          });
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage: "Error al enviar los recordatorios",
                        });
                      });
                  }}
                >
                  <Typography variant="body2" style={{ marginTop: "10px" }}>
                    Se enviará un email de recordatorio a todos los usuarios
                    inscritos en este curso ({curso?.inscripciones?.length || 0}{" "}
                    inscripciones).
                    <br />
                    <br />
                    ¿Deseas continuar?
                  </Typography>
                </ConfirmDialog>
                <ConfirmDialog
                  title="¿Borrar este comentario o valoración?"
                  open={openConfirmDialog === 9}
                  setOpen={(value) => {
                    setOpenConfirmDialog(value);
                    if (!value) setRatingIdToDelete(null);
                  }}
                  onConfirm={() => {
                    if (!ratingIdToDelete) return;
                    deleteCursoRating(ratingIdToDelete)
                      .then(() => {
                        setRefreshRatings((r) => r + 1);
                        setRatingIdToDelete(null);
                        setOpenConfirmDialog(false);
                        alertSuccess({
                          customMessage: "Comentario borrado correctamente.",
                        });
                      })
                      .catch((err) => {
                        alertError({
                          error: err,
                          customMessage: "Error al borrar el comentario.",
                        });
                        setRatingIdToDelete(null);
                        setOpenConfirmDialog(false);
                      });
                  }}
                >
                  <Typography variant="body2" style={{ marginTop: "10px" }}>
                    La valoración y el comentario se eliminarán de forma
                    permanente. ¿Deseas continuar?
                  </Typography>
                </ConfirmDialog>
              </>
            )}
          </>
        )}

        {/* Modal para editar/crear inscripción */}
        <Dialog
          open={openInscripcionModal}
          onClose={() => {
            setOpenInscripcionModal(false);
            setCurrentInscripcion(null);
            setSelectedUserInscripcion(null);
            setEditedUserData(null);
            setIsCreatingNewUser(false);
            setUserSearchText("");
            setUserSearchFiltered("");
          }}
          maxWidth="md"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog",
          }}
          disableEnforceFocus={openModalAddUser}
          disableAutoFocus={openModalAddUser}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <style>
            {`
              .custom-dialog {
                z-index: 1200 !important;
              }
              .custom-dialog .MuiPaper-root {
                z-index: 1200 !important;
              }
            `}
            {`
              .MuiAutocomplete-popper[style] {
                z-index: 1300 !important;
              }
              .MuiAutocomplete-paper {
                z-index: 1300 !important;
              }
              .MuiPopover-root {
                z-index: 1300 !important;
              }
              .MuiPaper-root.MuiAutocomplete-paper {
                z-index: 1300 !important;
              }
              [role="presentation"].MuiAutocomplete-popper {
                z-index: 1300 !important;
              }
              .MuiAutocomplete-listbox {
                z-index: 1300 !important;
              }
            `}
            {`
              /* Evitar scroll horizontal en la tabla del modal de inscripciones */
              .custom-dialog .table-responsive {
                overflow-x: hidden !important;
                overflow-y: visible !important;
              }
              .custom-dialog .react-bootstrap-table {
                overflow-x: hidden !important;
                overflow-y: visible !important;
              }
              .custom-dialog table {
                width: 100% !important;
                table-layout: auto !important;
              }
            `}
          </style>
          <DialogTitle>
            {currentInscripcion ? "Editar Inscripción" : "Nueva Inscripción"}
          </DialogTitle>
          <DialogContent>
            <div style={{ paddingTop: "20px" }}>
              {/* Selección de usuario */}
              <div className="mb-3">
                {currentInscripcion?._id ? (
                  // En edición: mostrar campos editables del usuario
                  <>
                    <Typography
                      variant="h6"
                      style={{ marginBottom: "20px", marginTop: "10px" }}
                    >
                      Datos del Alumno
                    </Typography>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Nombre"
                          value={editedUserData?.fullName || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              fullName: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Apellido 1"
                          value={editedUserData?.apellido1 || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              apellido1: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Apellido 2"
                          value={editedUserData?.apellido2 || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              apellido2: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="NIF/DNI"
                          value={editedUserData?.dni || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              dni: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Email"
                          type="email"
                          value={editedUserData?.email || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              email: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Teléfono"
                          value={editedUserData?.telefono || ""}
                          onChange={(e) => {
                            setEditedUserData({
                              ...editedUserData,
                              telefono: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </div>
                    </div>
                    <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
                  </>
                ) : (
                  // En creación: mostrar tabla de usuarios con filtros y búsqueda
                  <>
                    {/* Campo de búsqueda personalizado */}
                    <div
                      className="d-flex align-items-center mb-3"
                      style={{ gap: "10px" }}
                    >
                      <TextField
                        margin="normal"
                        variant="outlined"
                        label="Buscar usuario"
                        placeholder="Buscar por nombre, email o DNI (mínimo 3 caracteres)..."
                        InputLabelProps={{ shrink: true }}
                        value={userSearchText}
                        onChange={(e) => setUserSearchText(e.target.value)}
                        fullWidth
                        style={{ marginTop: 0, marginBottom: 0 }}
                      />
                      {userSearchText && (
                        <IconButton
                          onClick={() => {
                            setUserSearchText("");
                            setUserSearchFiltered("");
                          }}
                          style={{ marginTop: "8px" }}
                        >
                          <Clear />
                        </IconButton>
                      )}
                      {/* Botón para crear usuario nuevo */}
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<PersonAdd />}
                        onClick={() => {
                          setIsCreatingNewUser(true);
                          setOpenModalAddUser(true);
                        }}
                        style={{ marginTop: "8px", whiteSpace: "nowrap" }}
                      >
                        Crear usuario
                      </Button>
                    </div>
                    <Table
                      data={(users || [])
                        .filter((u) => {
                          // Excluir admin y gestor
                          if (
                            u.role === "admin" ||
                            u.role === "gestor" ||
                            u.role === "operario"
                          ) {
                            return false;
                          }
                          // Excluir usuarios que ya están inscritos en el curso
                          if (
                            curso?.inscripciones &&
                            Array.isArray(curso.inscripciones)
                          ) {
                            const userId = String(u._id);
                            const yaInscrito = curso.inscripciones.some(
                              (insc) => {
                                if (!insc || !insc.user) return false;
                                const inscUserId = String(insc.user);
                                return userId === inscUserId;
                              },
                            );
                            if (yaInscrito) return false;
                          }
                          // Aplicar filtro de búsqueda si hay texto (mínimo 3 caracteres)
                          if (
                            userSearchFiltered &&
                            userSearchFiltered.length >= 3
                          ) {
                            const search = userSearchFiltered.toLowerCase();
                            const fullName = `${u.fullName ||
                              ""} ${u.apellido1 || ""} ${u.apellido2 ||
                              ""}`.toLowerCase();
                            const email = (u.email || "").toLowerCase();
                            const dni = (u.dni || "").toLowerCase();
                            if (
                              !fullName.includes(search) &&
                              !email.includes(search) &&
                              !dni.includes(search)
                            ) {
                              return false;
                            }
                          }
                          return true;
                        })
                        .map((u) => ({
                          ...u,
                          fullName:
                            `${u.fullName || ""} ${u.apellido1 ||
                              ""} ${u.apellido2 || ""}`.trim() ||
                            u.fullName ||
                            "",
                        }))}
                      columns={[
                        { dataField: "fullName", text: "Nombre", sort: true },
                        { dataField: "dni", text: "DNI", sort: true },
                        { dataField: "email", text: "Email", sort: true },
                        { dataField: "role", text: "Rol", sort: true },
                        {
                          dataField: "_id",
                          text: "",
                          formatter: (cell) => {
                            const userRow = (users || []).find(
                              (u) => u._id === cell,
                            );
                            return (
                              <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setSelectedUserInscripcion(userRow || null);
                                }}
                              >
                                Seleccionar
                              </Button>
                            );
                          },
                        },
                      ]}
                      pageKey={`curso-${cursoId}-inscripciones-select-user`}
                      sizePerPage={100}
                      searchText=""
                      onSearchChange={() => {}}
                    />
                    {selectedUserInscripcion && (
                      <div style={{ marginTop: "10px" }}>
                        <Typography variant="body2">
                          Usuario seleccionado:{" "}
                          <strong>
                            {selectedUserInscripcion.fullName}
                            {selectedUserInscripcion.dni &&
                              ` (${selectedUserInscripcion.dni})`}
                          </strong>
                        </Typography>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Campos de vinculación */}
              {selectedUserInscripcion && (
                <>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Autocomplete
                        options={["Pendiente", "Pagado", "Rechazado"]}
                        value={currentInscripcion?.pagado || ""}
                        onChange={(event, selected) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            pagado: selected || "",
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                            label="Estado del pago"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        PopperProps={{
                          style: { zIndex: 1300 },
                          disablePortal: false,
                        }}
                        ListboxProps={{
                          style: { zIndex: 1300 },
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              zIndex: 1300,
                            },
                          },
                          style: {
                            zIndex: 1300,
                          },
                        }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <Autocomplete
                        options={["sin asignar", "si", "no"]}
                        value={currentInscripcion?.aprovado || "sin asignar"}
                        onChange={(event, selected) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            aprovado: selected || "sin asignar",
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                            label="Aprovado"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        PopperProps={{
                          style: { zIndex: 1300 },
                          disablePortal: false,
                        }}
                        ListboxProps={{
                          style: { zIndex: 1300 },
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              zIndex: 1300,
                            },
                          },
                          style: {
                            zIndex: 1300,
                          },
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Fecha de pago"
                        type="date"
                        value={
                          currentInscripcion?.fechaPago
                            ? (() => {
                                try {
                                  const date = new Date(
                                    currentInscripcion.fechaPago,
                                  );
                                  if (isNaN(date.getTime())) return "";
                                  return date.toISOString().split("T")[0];
                                } catch {
                                  return "";
                                }
                              })()
                            : ""
                        }
                        onChange={(e) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            fechaPago: e.target.value
                              ? new Date(e.target.value).toISOString()
                              : "",
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Código pago"
                        value={currentInscripcion?.codigoPago || ""}
                        onChange={(e) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            codigoPago: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Certificado de inscripción (Nº Reg)"
                        value={currentInscripcion?.nRegistro || ""}
                        onChange={(e) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            nRegistro: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Número de certificado"
                        placeholder="Ej: 0001 o CODIGO-0001"
                        value={currentInscripcion?.certificado || ""}
                        onChange={(e) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            certificado: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={currentInscripcion?.active !== false}
                            onChange={(e) => {
                              setCurrentInscripcion({
                                ...currentInscripcion,
                                active: e.target.checked,
                              });
                            }}
                            name="checkActive"
                          />
                        }
                        label="Estado (Activo)"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <TextField
                        label="Observaciones"
                        value={currentInscripcion?.obs || ""}
                        onChange={(e) => {
                          setCurrentInscripcion({
                            ...currentInscripcion,
                            obs: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        multiline
                        rows={3}
                        fullWidth
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenInscripcionModal(false);
                setCurrentInscripcion(null);
                setSelectedUserInscripcion(null);
                setEditedUserData(null);
                setIsCreatingNewUser(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={async () => {
                if (!selectedUserInscripcion) {
                  alertError({
                    error: new Error("Debe seleccionar un usuario"),
                    customMessage: "Debe seleccionar un usuario",
                  });
                  return;
                }

                try {
                  // Si estamos editando y hay cambios en los datos del usuario, guardarlos primero
                  if (currentInscripcion?._id && editedUserData) {
                    const userChanges = {};
                    let hasChanges = false;

                    // Verificar qué campos han cambiado
                    if (
                      editedUserData.fullName !==
                      selectedUserInscripcion.fullName
                    ) {
                      userChanges.fullName = editedUserData.fullName;
                      hasChanges = true;
                    }
                    if (
                      editedUserData.apellido1 !==
                      selectedUserInscripcion.apellido1
                    ) {
                      userChanges.apellido1 = editedUserData.apellido1;
                      hasChanges = true;
                    }
                    if (
                      editedUserData.apellido2 !==
                      selectedUserInscripcion.apellido2
                    ) {
                      userChanges.apellido2 = editedUserData.apellido2;
                      hasChanges = true;
                    }
                    if (editedUserData.dni !== selectedUserInscripcion.dni) {
                      userChanges.dni = editedUserData.dni;
                      hasChanges = true;
                    }
                    if (
                      editedUserData.email !== selectedUserInscripcion.email
                    ) {
                      userChanges.email = editedUserData.email;
                      hasChanges = true;
                    }
                    if (
                      editedUserData.telefono !==
                      selectedUserInscripcion.telefono
                    ) {
                      userChanges.telefono = editedUserData.telefono;
                      hasChanges = true;
                    }

                    // Si hay cambios, actualizar el usuario
                    if (hasChanges) {
                      const updatedUser = {
                        ...selectedUserInscripcion,
                        ...userChanges,
                      };
                      await updateUser(
                        selectedUserInscripcion._id,
                        updatedUser,
                      );
                      // Actualizar la lista de usuarios localmente
                      const updatedUsers = users.map((u) =>
                        u._id === selectedUserInscripcion._id ? updatedUser : u,
                      );
                      setUsers(updatedUsers);
                      setSelectedUserInscripcion(updatedUser);
                    }
                  }

                  let saveCurso = { ...curso };
                  const { paymentInfo, code, ...inscripcionRest } =
                    currentInscripcion || {};
                  let saveInscripcion = {
                    ...inscripcionRest,
                    user: selectedUserInscripcion._id,
                    aprovado: currentInscripcion?.aprovado || "sin asignar",
                    active: currentInscripcion?.active !== false,
                    codigoPago:
                      currentInscripcion?.codigoPago ||
                      currentInscripcion?.code ||
                      "",
                  };

                  if (currentInscripcion?._id) {
                    // Editar inscripción existente
                    saveCurso.inscripciones = saveCurso.inscripciones.map(
                      (item) =>
                        item._id === currentInscripcion._id
                          ? saveInscripcion
                          : item,
                    );
                  } else {
                    // Crear nueva inscripción
                    if (!Array.isArray(saveCurso.inscripciones)) {
                      saveCurso.inscripciones = [];
                    }
                    saveCurso.inscripciones.push(saveInscripcion);
                  }

                  const res = await updateCurso(cursoId, saveCurso);
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Guardado!",
                      customMessage: "Inscripción guardada correctamente",
                    });
                    setCurso(res.data);
                    setOpenInscripcionModal(false);
                    setCurrentInscripcion(null);
                    setSelectedUserInscripcion(null);
                    setEditedUserData(null);
                    setIsCreatingNewUser(false);
                    setRefreshInscritos(true);
                  }
                } catch (error) {
                  alertError({
                    error: error,
                    customMessage: "No se pudo guardar la inscripción",
                  });
                }
              }}
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#f3691a" }}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para crear usuario nuevo */}
        {isCreatingNewUser && (
          <UserFormModal
            open={openModalAddUser}
            setOpen={(open) => {
              setOpenModalAddUser(open);
              if (!open) setIsCreatingNewUser(false);
            }}
            onSave={async (resUser) => {
              const newUser = resUser.user || resUser;
              // Recargar la lista completa de usuarios desde el servidor
              try {
                const res = await getUsers();
                const allUsers = res.data || [];
                setUsers(allUsers);
                // Buscar el usuario recién creado en la lista actualizada
                const createdUser =
                  allUsers.find((u) => u._id === newUser._id) || newUser;
                setSelectedUserInscripcion(createdUser);
              } catch (error) {
                // Si falla la recarga, usar el usuario devuelto directamente
                setUsers([...users, newUser]);
                setSelectedUserInscripcion(newUser);
              }
              setIsCreatingNewUser(false);
              setOpenModalAddUser(false);
            }}
            userTypes={userTypes}
            defaultUserType={
              userTypes.find(
                (ut) =>
                  ut.titulo &&
                  (ut.titulo.toLowerCase().includes("usuario web registrado") ||
                    ut.titulo.toLowerCase().includes("web registrado") ||
                    ut.titulo.toLowerCase().includes("usuario registrado")),
              ) || userTypes.find((ut) => !ut.asociado)
            }
          />
        )}

        {/* Modal para añadir/editar docente */}
        <Dialog
          open={openDocenteModal}
          onClose={() => {
            setOpenDocenteModal(false);
            setCurrentDocente(null);
            setSelectedUserDocente(null);
            setIsCreatingNewUserDocente(false);
            setDocenteSearchText("");
            setDocenteSearchFiltered("");
          }}
          maxWidth="md"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog",
          }}
          disableEnforceFocus={openModalAddUserDocente}
          disableAutoFocus={openModalAddUserDocente}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <style>
            {`
              .custom-dialog {
                z-index: 1200 !important;
              }
              .custom-dialog .MuiPaper-root {
                z-index: 1200 !important;
              }
            `}
            {`
              .MuiAutocomplete-popper[style] {
                z-index: 1300 !important;
              }
              .MuiAutocomplete-paper {
                z-index: 1300 !important;
              }
              .MuiPopover-root {
                z-index: 1300 !important;
              }
              .MuiPaper-root.MuiAutocomplete-paper {
                z-index: 1300 !important;
              }
              [role="presentation"].MuiAutocomplete-popper {
                z-index: 1300 !important;
              }
              .MuiAutocomplete-listbox {
                z-index: 1300 !important;
              }
            `}
          </style>
          <DialogTitle>
            {currentDocente?._id ? "Editar Docente" : "Nuevo Docente"}
          </DialogTitle>
          <DialogContent>
            <div style={{ paddingTop: "20px" }}>
              {/* Selección de docente */}
              <div className="mb-3">
                {currentDocente?._id ? (
                  // En edición: mostrar docente fijo (solo lectura)
                  <TextField
                    margin="normal"
                    variant="outlined"
                    label="Docente"
                    InputLabelProps={{ shrink: true }}
                    value={
                      selectedUserDocente
                        ? `${(selectedUserDocente.fullName || "").trim()} ${(
                            selectedUserDocente.apellido1 || ""
                          ).trim()} ${(
                            selectedUserDocente.apellido2 || ""
                          ).trim()}`.trim() ||
                          (selectedUserDocente.fullName || "") +
                            " " +
                            (selectedUserDocente.dni || "")
                        : ""
                    }
                    disabled
                    fullWidth
                  />
                ) : (
                  // En creación: tabla de docentes con búsqueda (como inscripciones)
                  <>
                    <div
                      className="d-flex align-items-center mb-3"
                      style={{ gap: "10px" }}
                    >
                      <TextField
                        margin="normal"
                        variant="outlined"
                        label="Buscar docente"
                        placeholder="Buscar por nombre, apellidos, email o NIF (mínimo 3 caracteres)..."
                        InputLabelProps={{ shrink: true }}
                        value={docenteSearchText}
                        onChange={(e) => setDocenteSearchText(e.target.value)}
                        fullWidth
                        style={{ marginTop: 0, marginBottom: 0 }}
                      />
                      {docenteSearchText && (
                        <IconButton
                          onClick={() => {
                            setDocenteSearchText("");
                            setDocenteSearchFiltered("");
                          }}
                          style={{ marginTop: "8px" }}
                        >
                          <Clear />
                        </IconButton>
                      )}
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<PersonAdd />}
                        onClick={() => {
                          setIsCreatingNewUserDocente(true);
                          setOpenModalAddUserDocente(true);
                        }}
                        style={{ marginTop: "8px", whiteSpace: "nowrap" }}
                      >
                        Crear docente
                      </Button>
                    </div>
                    <Table
                      data={(users || []).filter((u) => {
                        const esDocente =
                          u?.role === "docente" || u?.esDocente === true;
                        if (!esDocente) return false;
                        if (curso?.docentes && Array.isArray(curso.docentes)) {
                          const userId = String(u._id);
                          const yaAsignado = curso.docentes.some((d) => {
                            if (!d || !d.docente) return false;
                            return userId === String(d.docente);
                          });
                          if (yaAsignado) return false;
                        }
                        if (
                          docenteSearchFiltered &&
                          docenteSearchFiltered.length >= 3
                        ) {
                          const search = docenteSearchFiltered.toLowerCase();
                          const fullName = `${u.fullName || ""} ${u.apellido1 ||
                            ""} ${u.apellido2 || ""}`.toLowerCase();
                          const email = (u.email || "").toLowerCase();
                          const dni = (u.dni || "").toLowerCase();
                          if (
                            !fullName.includes(search) &&
                            !email.includes(search) &&
                            !dni.includes(search)
                          ) {
                            return false;
                          }
                        }
                        return true;
                      })}
                      columns={[
                        {
                          dataField: "fullName",
                          text: "Nombre",
                          sort: true,
                        },
                        {
                          dataField: "apellido1",
                          text: "Apellido 1",
                          sort: true,
                        },
                        {
                          dataField: "apellido2",
                          text: "Apellido 2",
                          sort: true,
                        },
                        { dataField: "dni", text: "NIF", sort: true },
                        { dataField: "email", text: "Email", sort: true },
                        {
                          dataField: "_id",
                          text: "",
                          formatter: (cell) => {
                            const userRow = (users || []).find(
                              (u) => u._id === cell,
                            );
                            return (
                              <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() =>
                                  setSelectedUserDocente(userRow || null)
                                }
                              >
                                Seleccionar
                              </Button>
                            );
                          },
                        },
                      ]}
                      pageKey={`curso-${cursoId}-docentes-select-user`}
                      sizePerPage={100}
                      searchText=""
                      onSearchChange={() => {}}
                    />
                    {selectedUserDocente && (
                      <div style={{ marginTop: "10px" }}>
                        <Typography variant="body2">
                          Docente seleccionado:{" "}
                          <strong>
                            {(selectedUserDocente.fullName || "").trim()}{" "}
                            {(selectedUserDocente.apellido1 || "").trim()}{" "}
                            {(selectedUserDocente.apellido2 || "").trim()}
                            {selectedUserDocente.dni
                              ? ` (${selectedUserDocente.dni})`
                              : ""}
                          </strong>
                        </Typography>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Campos de docente */}
              {selectedUserDocente && (
                <>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Número de registro"
                        value={currentDocente?.nRegistro || ""}
                        onChange={(e) => {
                          setCurrentDocente({
                            ...currentDocente,
                            nRegistro: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <TextField
                        select
                        label="Aprobado"
                        value={currentDocente?.aprovado || "Sin asignar"}
                        onChange={(e) => {
                          setCurrentDocente({
                            ...currentDocente,
                            aprovado: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      >
                        <MenuItem value="Sin asignar">Sin asignar</MenuItem>
                        <MenuItem value="Aprobado">Aprobado</MenuItem>
                        <MenuItem value="No aprobado">No aprobado</MenuItem>
                      </TextField>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        label="Certificado (docente)"
                        value={currentDocente?.certificado || ""}
                        onChange={(e) => {
                          setCurrentDocente({
                            ...currentDocente,
                            certificado: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        placeholder="Ej: 0123"
                      />
                    </div>
                    {currentDocente?.esDirector && (
                      <div className="col-md-6 mb-3">
                        <TextField
                          label="Certificado director"
                          value={currentDocente?.certificadoDirector || ""}
                          onChange={(e) => {
                            setCurrentDocente({
                              ...currentDocente,
                              certificadoDirector: e.target.value,
                            });
                          }}
                          InputLabelProps={{ shrink: true }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          placeholder="Ej: 0124"
                        />
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <TextField
                        label="Observaciones"
                        value={currentDocente?.obs || ""}
                        onChange={(e) => {
                          setCurrentDocente({
                            ...currentDocente,
                            obs: e.target.value,
                          });
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        variant="outlined"
                        multiline
                        rows={3}
                        fullWidth
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={currentDocente?.active !== false}
                            onChange={(e) => {
                              setCurrentDocente({
                                ...currentDocente,
                                active: e.target.checked,
                              });
                            }}
                            name="checkActive"
                          />
                        }
                        label="Estado (Activo)"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!currentDocente?.esDirector}
                            onChange={(e) => {
                              setCurrentDocente({
                                ...currentDocente,
                                esDirector: e.target.checked,
                              });
                            }}
                            name="checkDirector"
                          />
                        }
                        label="Director del curso (doble certificado; puede haber más de uno)"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenDocenteModal(false);
                setCurrentDocente(null);
                setSelectedUserDocente(null);
                setIsCreatingNewUserDocente(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={async () => {
                if (!selectedUserDocente) {
                  alertError({
                    error: new Error("Debe seleccionar un docente"),
                    customMessage: "Debe seleccionar un docente",
                  });
                  return;
                }

                let saveCurso = { ...curso };
                const isActive = currentDocente?.active !== false;
                // Si deja de ser activo (docente), se borran los certificados
                const certificado = isActive
                  ? currentDocente?.certificado || ""
                  : "";
                const certificadoDirector = isActive
                  ? currentDocente?.certificadoDirector || ""
                  : "";
                let saveDocente = {
                  ...currentDocente,
                  docente: selectedUserDocente._id,
                  active: isActive,
                  nRegistro: currentDocente?.nRegistro || "",
                  certificado,
                  certificadoDirector,
                  esDirector: !!currentDocente?.esDirector,
                  aprovado: currentDocente?.aprovado || "Sin asignar",
                };

                if (currentDocente?._id) {
                  // Editar docente existente
                  saveCurso.docentes = saveCurso.docentes.map((item) =>
                    item._id === currentDocente._id ? saveDocente : item,
                  );
                } else {
                  // Crear nuevo docente
                  if (!Array.isArray(saveCurso.docentes)) {
                    saveCurso.docentes = [];
                  }
                  saveCurso.docentes.push(saveDocente);
                }

                try {
                  const res = await updateCurso(cursoId, saveCurso);
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Guardado!",
                      customMessage: "Docente guardado correctamente",
                    });
                    setCurso(res.data);
                    setOpenDocenteModal(false);
                    setCurrentDocente(null);
                    setSelectedUserDocente(null);
                    setIsCreatingNewUserDocente(false);
                  }
                } catch (error) {
                  alertError({
                    error: error,
                    customMessage: "No se pudo guardar el docente",
                  });
                }
              }}
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#f3691a" }}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para crear usuario nuevo (docente) */}
        {isCreatingNewUserDocente && (
          <UserFormModal
            open={openModalAddUserDocente}
            setOpen={(open) => {
              setOpenModalAddUserDocente(open);
              if (!open) setIsCreatingNewUserDocente(false);
            }}
            onSave={(resUser) => {
              const newUser = resUser.user || resUser;
              setUsers([...users, newUser]);
              setSelectedUserDocente(newUser);
              setIsCreatingNewUserDocente(false);
              setOpenModalAddUserDocente(false);
            }}
            userTypes={userTypes}
            submitRole="docente"
            defaultUserType={
              userTypes.find(
                (ut) =>
                  ut.titulo &&
                  (ut.titulo.toLowerCase().includes("docente") ||
                    ut.titulo.toLowerCase().includes("profesor")),
              ) || userTypes.find((ut) => !ut.asociado)
            }
          />
        )}

        {/* Diálogos de selección de imageStorage */}
        <ImageStorageSelectorDialog
          open={openImageSelector}
          onClose={() => setOpenImageSelector(false)}
          onSelect={(url) => {
            setCurso({ ...curso, imageURL: url });
            setSelectedLogo(null);
          }}
          filterType="imagen"
          title="Seleccionar imagen"
        />
        <ImageStorageSelectorDialog
          open={openImageGridSelector}
          onClose={() => setOpenImageGridSelector(false)}
          onSelect={(url) => {
            setCurso({ ...curso, imageGridURL: url });
            setSelectedLogoGrid(null);
          }}
          filterType="imagen"
          title="Seleccionar imagen para grid"
        />
      </>
    );
}
